import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator'
import ToolkitProvider, {
  Search,
  CSVExport,
} from 'react-bootstrap-table2-toolkit'
import {
  // ConfigProvider,
  // DatePicker,
  Select,
  // Input,
  Checkbox,
  Switch,
  InputNumber,
  Tooltip,
} from 'antd'
import BootstrapTable from 'react-bootstrap-table-next'
import {
  Col,
  Row,
  Modal,
  Button,
  Badge,
  Card,
  Accordion,
  DropdownButton,
  Dropdown,
  Tabs,
  Tab,
  // Button
} from 'react-bootstrap'
// import enUS from "antd/es/locale/en_US";
import React, { Component } from 'react'
import Swal from 'sweetalert2'
import reactswal from '@sweetalert/with-react'

import moment from 'moment'
import $ from 'jquery'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LoadingOverlay from 'react-loading-overlay'
import BounceLoader from 'react-spinners/BounceLoader'
import AddCandidatesToProjectModal from '../AddCandidatesToProjectModal'
import ExportCSVModal from './ExportCSVModal'
import LeadQuickViewDrawer from './LeadQuickViewDrawer'
import axios from 'axios'
import Cookies from 'universal-cookie'
import { toast } from 'react-toastify'
import Searchable from 'react-searchable-dropdown'
import { useEffect } from 'react'
import { isUserRestricted, getDefaultProjectFilterName } from './leadHelpers'
import { getAllApiariesService } from '../../../services/apiaryService'

const cookies = new Cookies()
const { ExportCSVButton } = CSVExport

// import { ScaleLoader } from "react-spinners";
// import { indexOf } from "lodash";
var createHost = require('cross-domain-storage/host')
// import createHost from 'cross-domain-storage/host'

// import { allBanks} from '../../../commonConfig';
// import Check from "../../../../public/images/check.png";
// import Cancel from "../../../../public/images/cancel.png";

const readCookie = require('../cookie.js').readCookie
const currentToken = readCookie('access_token')

// use when reading any nested string
const safeRead = (fn, defaultVal = '') => {
  try {
    const v = fn();
    return (v === null || v === undefined) ? defaultVal : v;
  } catch (e) {
    return defaultVal;
  }
};


// const getRatiosString = (creditCount, selfInvestmentCount) => {
//   if (creditCount <= 0) return [].join("");

//   if (selfInvestmentCount <= 0)
//     return `Please ensure that the payment claims are raised only once a month and includes only credit linked candidates`;

//   let ratios = [];
//   // for ()
//   let numer = Math.round(creditCount / 5);
//   let denom = Math.round(selfInvestmentCount / 5);
//   for (let i = 1; i <= 4; i++) {
//     ratios.push(`${numer * i}:${denom * i}`);
//   }
//   // while (hcf < 5) {
//   // 	numer = numer+1;
//   // 	hcf = findHCF(numer, denom);
//   // 	console.log(hcf, numer, denom);

//   // }
//   ratios.push(`${creditCount}:${selfInvestmentCount}`);
//   return `Please ensure that the payment claims are raised only once a month and in the ratio (credit linked : 100 % self investment) - ${ratios.join(
//     " or "
//   )}`;
// };
const { SearchBar } = Search
// const { RangePicker } = DatePicker;
const { Option, OptGroup } = Select

// var storageHost = createHost([
//   {
//     origin: process.env.REACT_APP_CAMPAIGN_URL,
//     allowedMethods: ['get', 'set', 'remove'],
//   }
// ]);

export default class Leads extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // ... existing state ...
      basicProfiles: [], // Add this for basic profiles
      combinedData: [],  // Add this for combined data
      hideUnwantedFilters: false,
      allSupportServices: [],
      showImportModal: false,
      leadsLoading: true,
      importing: false,
      candidatesImportFile: null,
      allLeads: [],
      allStates: [],
      focusStates: [],
      allVillages: [],  // Add this
      allBlocks: [],    // Add this
      searchText: '',
      allSaarthis: [],
      allDistricts: [],
      allSources: [],
      allBusinessIdeas: [],
      swavalambanFellows: [],
      allMilestones: [],
      projects: [],
      filterData: {
        projectName: isUserRestricted() && getDefaultProjectFilterName() ? [getDefaultProjectFilterName()] : [],
        district: [],
        village: [],     // Add this
        block: [],       // Add this
        srlm_associated: '', // Add this
        apiaryStatus: '', // Add this: '' (All), 'Active', 'Inactive', 'Absent'
        essOptedFor: '',
        paymentClaim: '',
        scaleUpQuestionnaire: '',
        bplanAge: '',
        pwd: '',
        idea: '',
        phase: '',
        audit: '',
        entrepreneurStoryVerification: '',
        state: '',
        gender: '',
        cluster: [],
        category: '',
        source: '',
        // district: [],
        userType: '',
        taggedTo: '',
        toDate: null,
        onHold: false,
        collateral: '',
        starred: false,
        fromDate: null,
        assignedTo: '',
        hasComments: '',
        financeType: '',
        bankAccounts: [],
        minLoanAmount: '',
        maxLoanAmount: '',
        filedIncomeTax: '',
        maturityStatus: [],
        strengthRating: '',
        ddOnHoldReasons: [],
        bpOnHoldReasons: [],
        disqualified: false,
        profilingStages: [],
        overallSentiment: '',
        modeOfApplication: '',
        profilingStage: false,
        dueDiligenceStages: [],
        businessPlanStages: [],
        dueDiligenceStage: false,
        businessPlanStage: false,
        enterpriseSetupStages: [],
        capitalFulfilledStatus: [],
        capitalFulfilledStages: [],
        disqualificationReasons: [],
        enterpriseSetupStage: false,
        capitalFulfilledStage: false,
        businessPlanVerification: '',
        tentativeHorizonToCloseThis: '',
        enterpriseSustainabilityStages: [],
        enterpriseSustainabilityStage: false,
        loanSchemeId: [],
        loanScheme: [],
        sidbiMilestone: '',
        assignedToCluster: '',
        clusterName: null,
        stage: '',
        // NEW FILTERS
        landOwnerShip: '',
        practiceBeekeeping: '',
        trainedinBeekeepingProgram: '',
        interestedinMoreBeeBoxes: '',
        useChemical: '',
        ownCattle: '',
        education: '',
        reportedBy: [],
      },
      userData: cookies.get('userData'),
      allBanks: [],
      allLoanSchemes: [],
      page: 1,
      totalLeads: 1000,
      leadCounts: {},
      allUserTypes: [],
      sizePerPage: 500,
      activeTab: 'basic',
      allAssignedTo: [],
      showFilter: false,
      sizePerPageList: [10, 25, 50, 100, 500, 1000, 2000, 3000, 5000],
      ddOnHoldReasons: [
        'Unresponsive (Not picking up)',
        'Unresponsive (Unable to connect/Switched off)',
        'Interested to start business after some time',
        'Applicant different from entrepreneur: Has no idea of the business',
        'Business Idea not finalized',
        'Less idea about why to start the business',
        'Business Idea requires license, but candidate does not have those',
        'Need more time to know the exact location to start the business',
        'Need more time to identify target customers',
        'Need more time to estimate monthly sales and costs',
        'Need more time to find nearby competitive businesses',
        'Need more time to find the place to buy goods/machines/raw materials',
        'Previous loan taken and ongoing',
        'Need more time to supply quotations corresponding to items purchased',
        'Candidate has no PAN',
        'Other Reason',
      ],
      bpOnHoldReasons: [
        'Unresponsive (Not picking up)',
        'Unresponsive (Unable to connect/Switched off)',
        'Submission of quotations shall take time',
        'Not keen to visit bank(s) at the moment',
        'Business location not finalized',
        'Business metrics (assumptions) not finalized',
        'Collateral/Security related documents pending',
        'Required license/rent deed/other key document pending',
        'Skill/EDP training pending',
        'Other Reason',
      ],
      disqualificationReasons: [
        'No longer interested',
        'Has no idea/intention of starting up',
        'Spam caller',
        'Not able to get in touch at all',
        'Migrated',
        'Passed away',
        'Poor CIBIL score',
        'Only looking for bank loan (not very genuine)',
        'Scale-up: Has availed credit linkage before',
        'Duplicate lead',
        'Other Reason',
      ],
      // Changes for follow up data
      followUpCounts: { dueThisWeek: 0, dueToday: 0, overDue: 0 },
      followUpDues: { dueThisWeek: [], dueToday: [], overDue: [] },
      followUpFilters: { today: false, overDue: false, week: false },
      showFollowUpModule: false,
      enterpriseProgressStats: {},
      selectMode: false,
      selectAllLeadsQuery: '',
      selectedLeads: [],
      selectedLeadsIds: [],
      countSelectedLeads: 0,
      selectAllLeadsInfo: [],
      showAddLeadsToProjectModal: false,
      showExportCSVModal: false,
      allLeadsSelected: false,
      projectMoveAction: '',
      allUsers: [],
      allData: [],
      clusterData: [],
      filteredUsers: [], // Data to render after filtering
      searchTextFilter: '',
      quickViewDrawerVisible: false,
      quickViewLeadId: null,
    }
  }




  // handleSearch = e => { original
  //   const searchText = e.target.value
  //   this.setState({ searchText })
  //   console.log(searchText)
  //   if (searchText.length == 0) {
  //     this.setState({ filteredUsers: [] })
  //     return
  //   }
  //   const filteredUsers = this.state.allUsers.filter(user => {
  //     return (
  //       user.userInfo.name?.toLowerCase().includes(searchText.toLowerCase()) ||
  //       user.userInfo.mobileNumber?.toString().includes(searchText)
  //     )
  //   })
  //   console.log(filteredUsers, this.state.allUsers)
  //   this.setState({ filteredUsers })
  // }

  // 8. FIX: Update the search handler
  handleSearch = e => {
    const searchText = e.target.value.toLowerCase();
    this.setState({ searchText });

    if (searchText.length === 0) {
      this.setState({ filteredUsers: this.state.allUsers });
      return;
    }

    const filteredUsers = this.state.allUsers.filter(user => {
      const name = user.userInfo?.name?.toLowerCase() || '';
      const mobile = user.userInfo?.mobileNumber?.toString() || '';
      const pincode = user.userInfo?.address?.pincode?.toString() || '';

      return (
        name.includes(searchText) ||
        mobile.includes(searchText) ||
        pincode.includes(searchText)
      );
    });

    this.setState({ filteredUsers });
  };

  hideAddLeadsToProjectModal = (addedToProject = false) => {
    this.setState({ showAddLeadsToProjectModal: false })
    if (addedToProject) {
      this.setState({
        selectedLeads: [],
        selectedLeadsIds: [],
        allLeadsSelected: false,
        countSelectedLeads: 0,
        selectMode: false,
      })
      this.submitFilter('page')
    }
  }
  getCreditStats = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/v1/stats/credit-stats', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ enterpriseProgressStats: data.stats || {} })
        }
      })
  }

  fetchProjects = () => {
    fetch(process.env.REACT_APP_API_URL + `/api/v1/project/no-pid-auth`, {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
        // 'project': userData.id
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status === 'ok') {
          this.setState({ projects: data.projects }, () => {
            if (isUserRestricted()) {
              const defaultName = getDefaultProjectFilterName(data.projects);
              if (defaultName) {
                this.setState(prevState => ({
                  filterData: {
                    ...prevState.filterData,
                    projectName: [defaultName]
                  }
                }), () => {
                  this.applyFilters();
                });
              }
            }
          })
        }
      })
  }

  getAllClusters = async () => {
    try {
      const currentToken = cookies.get('access_token')

      const res = await axios.get(
        `${process.env.REACT_APP_HUMBLEBEE_API_URL}/projects/clusters/getAll`,
        {
          headers: {
            authorization: `Bearer ${currentToken}`,
          },
        }
      )

      console.log('res.data.clusters: ', res.data.clusters)
      var data = res.data.clusters
      return data
    } catch (err) {
      console.log('err', err)
    }
  }

  // 5. UPDATE combineProfileData to ensure proper stage assignment
  combineProfileData = (basicProfiles, baselineData) => {
    const combined = [];
    const seenUserIds = new Set();
    const seenMobiles = new Set();

    console.log("Combining profiles:", {
      basicCount: basicProfiles?.length || 0,
      baselineCount: baselineData?.length || 0
    });

    // 1. Process baseline survey data (stage = "advance") first
    if (baselineData && baselineData.length) {
      baselineData.forEach((item, idx) => {
        const userId = item._id || item.userInfo?._id;
        const mobile = item.userInfo?.mobileNumber ? item.userInfo.mobileNumber.toString().replace(/\D/g, '').slice(-10) : '';

        // Deduplicate baseline data if same candidate appears multiple times
        const isDuplicateUser = userId && seenUserIds.has(userId.toString());
        const isDuplicateMobile = mobile && mobile !== '0000000000' && seenMobiles.has(mobile);

        if (isDuplicateUser || isDuplicateMobile) {
          console.log("Skipping duplicate baseline profile:", item.userInfo?.name, userId, mobile);
          return;
        }

        if (userId) seenUserIds.add(userId.toString());
        if (mobile && mobile !== '0000000000') seenMobiles.add(mobile);

        const uniqueKey = userId ? userId.toString() : `advance_${idx}_${Date.now()}`;

        combined.push({
          ...item,
          stage: 'advance', // Explicitly set stage
          surveyorName: item.surveyData?.created_by?.name || null,
          _id: uniqueKey,
          id: uniqueKey,
          // Add default values for basic profile fields if not present
          aadhar_number: item.aadhar_number || null,
          srlm_associated: item.srlm_associated || false,
          userInfo: {
            ...item.userInfo,
            address: {
              ...item.userInfo?.address,
              village: item.userInfo?.address?.village || null,
              block: item.userInfo?.address?.block || null,
              logged_in: item.userInfo?.logged_in || false,
              addedAt: item.userInfo?.addedAt || item.userInfo?.created_at,
            }
          }
        });
      });
    }

    // 2. Process basic profiles (stage = "basic") second - only add if not already in combined
    if (basicProfiles && basicProfiles.length) {
      basicProfiles.forEach((profile, idx) => {
        const mobile = profile.mobile_number ? profile.mobile_number.toString().replace(/\D/g, '').slice(-10) : '';
        const userId = profile._id || profile.id;

        const existsAsAdvance = combined.some(
          x => (mobile && x.userInfo?.mobileNumber?.toString().replace(/\D/g, '').slice(-10) === mobile) ||
               (userId && (x._id === userId.toString() || x.userInfo?._id?.toString() === userId.toString()))
        );

        if (!existsAsAdvance) {
          const uniqueKey = userId ? userId.toString() : `basic_${idx}_${Date.now()}`;
          if (userId) seenUserIds.add(userId.toString());
          if (mobile && mobile !== '0000000000') seenMobiles.add(mobile);

          combined.push({
            _id: uniqueKey,
            id: uniqueKey,
            stage: 'basic', // Explicitly set stage
            surveyorName: profile.created_by_user?.name || null,
            userInfo: {
              _id: profile._id,
              name: profile.full_name,
              mobileNumber: profile.mobile_number,
              gender: profile.gender,
              address: {
                state: profile.state,
                district: profile.district,
                village: profile.village_name,
                block: profile.block,
                logged_in: profile.logged_in,
                addedAt: profile.created_at,
              }
            },
            fieldViewData: [{
              created_at: profile.created_at,
              updated_at: profile.updated_at,
              cluster_id: profile.cluster_id
            }],
            surveyData: {
              stages: [{
                form_data: {
                  dob: profile.dob
                }
              }]
            },
            // Add basic profile specific fields
            aadhar_number: profile.aadhar_number || null,
            srlm_associated: profile.srlm_associated || false,
            clusterName: null,
            projectName: null
          });
        } else {
          console.log("Skipping basic profile duplicate:", profile.full_name);
        }
      });
    }

    console.log("Combined result:", {
      total: combined.length,
      basic: combined.filter(x => x.stage === 'basic').length,
      advance: combined.filter(x => x.stage === 'advance').length
    });

    return combined;
  };

  // STEP 2: ADD function to get unique districts, villages and blocks from data
  getUniqueLocations = (data, stateFilter = '', districtFilter = []) => {
    let filteredData = data || this.state.allData || [];

    // Filter by state if selected - Check both basic and advance stage
    if (stateFilter) {
      filteredData = filteredData.filter(
        item => {
          // For basic stage: check userInfo.address.state
          const basicStageState = item.userInfo?.address?.state || '';

          // For advance stage: check surveyData.stages[0].form_data.state
          const advanceStageState = item.surveyData?.stages?.[0]?.form_data?.state || '';

          // Effective state displayed on table (basicStageState takes precedence if available)
          const effectiveState = (basicStageState || advanceStageState).trim();
          return effectiveState === stateFilter;
        }
      );
    }

    // Get unique districts - Check both basic and advance stage (extracted from data, not from API)
    const districts = [...new Set(
      filteredData
        .flatMap(item => {
          const districts = [];

          // Get district from basic stage
          const basicStageDistrict = item.userInfo?.address?.district;
          if (basicStageDistrict &&
            basicStageDistrict !== 'null' &&
            basicStageDistrict !== 'undefined' &&
            basicStageDistrict !== '' &&
            basicStageDistrict.toString().trim() !== '') {
            districts.push(basicStageDistrict.toString().trim());
          }

          // Get district from advance stage
          const advanceStageDistrict = item.surveyData?.stages?.[0]?.form_data?.district;
          if (advanceStageDistrict &&
            advanceStageDistrict !== 'null' &&
            advanceStageDistrict !== 'undefined' &&
            advanceStageDistrict !== '' &&
            advanceStageDistrict.toString().trim() !== '') {
            districts.push(advanceStageDistrict.toString().trim());
          }

          return districts;
        })
        .filter(d => d !== null && d !== '' && d !== undefined)
    )].sort();

    // Filter by district if selected - Check both basic and advance stage
    if (districtFilter && districtFilter.length > 0) {
      filteredData = filteredData.filter(
        item => {
          const basicStageDistrict = item.userInfo?.address?.district || '';
          const advanceStageDistrict = item.surveyData?.stages?.[0]?.form_data?.district || '';
          return districtFilter.includes(basicStageDistrict.trim()) || districtFilter.includes(advanceStageDistrict.trim());
        }
      );
    }

    // Get unique villages - Check both basic and advance stage
    const villages = [...new Set(
      filteredData
        .flatMap(item => {
          const villages = [];

          // Get village from basic stage
          const basicStageVillage = item.userInfo?.address?.village;
          if (basicStageVillage &&
            basicStageVillage !== 'null' &&
            basicStageVillage !== 'undefined' &&
            basicStageVillage !== '' &&
            basicStageVillage.toString().trim() !== '') {
            villages.push(basicStageVillage.toString().trim());
          }

          // Get village from advance stage
          const advanceStageVillage = item.surveyData?.stages?.[0]?.form_data?.village;
          if (advanceStageVillage &&
            advanceStageVillage !== 'null' &&
            advanceStageVillage !== 'undefined' &&
            advanceStageVillage !== '' &&
            advanceStageVillage.toString().trim() !== '') {
            villages.push(advanceStageVillage.toString().trim());
          }

          return villages;
        })
        .filter(v => v !== null && v !== '' && v !== undefined)
    )].sort();

    // Get unique blocks - Check both basic and advance stage
    const blocks = [...new Set(
      filteredData
        .flatMap(item => {
          const blocks = [];

          // Get block from basic stage
          const basicStageBlock = item.userInfo?.address?.block;
          if (basicStageBlock &&
            basicStageBlock !== 'null' &&
            basicStageBlock !== 'undefined' &&
            basicStageBlock !== '' &&
            basicStageBlock.toString().trim() !== '') {
            blocks.push(basicStageBlock.toString().trim());
          }

          // Get block from advance stage
          const advanceStageBlock = item.surveyData?.stages?.[0]?.form_data?.block;
          if (advanceStageBlock &&
            advanceStageBlock !== 'null' &&
            advanceStageBlock !== 'undefined' &&
            advanceStageBlock !== '' &&
            advanceStageBlock.toString().trim() !== '') {
            blocks.push(advanceStageBlock.toString().trim());
          }

          return blocks;
        })
        .filter(b => b !== null && b !== '' && b !== undefined)
    )].sort();

    console.log("Filtered data for locations:", filteredData.length);
    console.log("Unique districts:", districts);
    console.log("Unique villages:", villages);
    console.log("Unique blocks:", blocks);


    return { districts, villages, blocks };
  };


  // 4. UPDATE fetchAllProfileData to use correct endpoint
  fetchAllProfileData = async () => {
    try {
      this.setState({ leadsLoading: true });

      // Fetch basic profiles
      const basicResponse = await axios.get(
        `${process.env.REACT_APP_API_APP_FIELD_URL}/surveys/bp/admin-base-profile`,
        {
          headers: {
            source: "humblebee_admin",
            Authorization: "Bearer " + JSON.parse(readCookie("access_token")),
          },
        }
      );

      console.log("Basic profiles fetched:", basicResponse.data?.data?.length);

      // Fetch baseline survey data (ADVANCE profiles)
      // Use the SAME endpoint as componentWillMount was using
      const baselineResponse = await fetch(
        `${process.env.REACT_APP_API_APP_USER_URL}/user/getAllSurveyedUsers?limit=2000&role=trainee_beekeeper`,
        {
          method: 'GET',
          headers: {
            source: 'humblebee_admin',
            authorization: 'Bearer ' + 'humblbee_admin_token',
          },
        }
      );

      const baselineDataRaw = await baselineResponse.json();
      const baselineData = baselineDataRaw.userInfo || [];

      console.log("Baseline profiles fetched:", baselineData);

      const basicProfiles = basicResponse.data?.data || [];

      // Get cluster data
      const clusterData = await this.getAllClusters();

      // Combine the data
      let combinedData = this.combineProfileData(basicProfiles, baselineData);

      combinedData = combinedData.map(item => {
        const address = item.userInfo?.address || {};

        console.log("Trimming address for:", typeof address.village === "string" ? address.village.trim() : "empty",);
        console.log("Trimming address for:", typeof address.block === "string" ? address.block.trim() : "empty");

        return {
          ...item,
          userInfo: {
            ...item.userInfo,
            address: {
              ...address,
              village: typeof address.village === "string" ? address.village.trim() : "",
              block: typeof address.block === "string" ? address.block.trim() : "",
            }
          }
        };
      });


      console.log("Combined data:", {
        total: combinedData.length,
        basic: combinedData.filter(x => x.stage === 'basic').length,
        advance: combinedData.filter(x => x.stage === 'advance').length
      });

      // Map cluster names to combined data
      combinedData = combinedData.map(item => {
        const cluster = clusterData.find(
          cluster => cluster._id == item?.fieldViewData?.[0]?.cluster_id
        );
        return {
          ...item,
          clusterName: cluster?.clusterName || null,
          projectName: cluster?.projectId?.name || null,
          projectId: cluster?.projectId?._id || null,
        };
      });

      // Sort by updated_at
      combinedData.sort((a, b) => {
        return (
          new Date(b.fieldViewData?.[0]?.updated_at || 0) -
          new Date(a.fieldViewData?.[0]?.updated_at || 0)
        );
      });

      // Fetch Commercial Apiaries, Trainee Setup Reports, and per-user survey apiaries for leads
      let apiariesList = [];
      let traineeApiaryReports = [];
      try {
        const [apiariesRes, traineeReportsRes] = await Promise.allSettled([
          getAllApiariesService(),
          axios.get(`${process.env.REACT_APP_API_APP_FIELD_URL}/survey-report/all-survey-report/trainee_apiary_setup`, {
            headers: {
              source: 'humblebee_admin',
              Authorization: 'Bearer ' + currentToken,
            }
          })
        ]);

        if (apiariesRes.status === 'fulfilled') {
          apiariesList = apiariesRes.value || [];
        }
        if (traineeReportsRes.status === 'fulfilled') {
          const rawReports = traineeReportsRes.value?.data;
          traineeApiaryReports = Array.isArray(rawReports?.data) ? rawReports.data : (Array.isArray(rawReports) ? rawReports : []);
        }
      } catch (apiaryErr) {
        console.error("Error fetching apiaries for leads:", apiaryErr);
      }

      const apiaryMap = {};
      
      // 1. Process Commercial Nector Apiaries
      if (Array.isArray(apiariesList)) {
        apiariesList.forEach(apiary => {
          const mobileKeys = [
            apiary.mobile_number,
            apiary.mobile,
            apiary.beekeeper_mobile,
            apiary.phone
          ].filter(Boolean).map(m => m.toString().replace(/\D/g, '').slice(-10));

          const idKeys = [
            apiary.beekeeper_id,
            apiary.user_id,
            apiary.candidate_id,
            apiary._id
          ].filter(Boolean).map(id => id.toString());

          const isApiaryActive = apiary.is_active !== false && apiary.operational_status !== 'Disabled' && apiary.status !== 'INACTIVE';
          const statusVal = isApiaryActive ? 'Active' : 'Inactive';

          mobileKeys.forEach(key => { if (key) apiaryMap[key] = statusVal; });
          idKeys.forEach(key => { if (key) apiaryMap[key] = statusVal; });
        });
      }

      // 2. Process Trainee Apiary Setup Survey Reports
      if (Array.isArray(traineeApiaryReports)) {
        traineeApiaryReports.forEach(report => {
          const mobile = report.mobile_number ? report.mobile_number.toString().replace(/\D/g, '').slice(-10) : '';
          const userId = report.le_app_user ? report.le_app_user.toString() : '';

          if (mobile) apiaryMap[mobile] = 'Active';
          if (userId) apiaryMap[userId] = 'Active';
        });
      }

      // 3. Guarantee check: Fetch per-user survey apiaries in parallel for all candidates
      const userSurveyApiaryResults = await Promise.allSettled(
        combinedData.map(async (item) => {
          const userId = item.userInfo?._id || item._id || item.id;
          if (!userId) return null;
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_API_APP_FIELD_URL}/surveys/user/${userId}`,
              {
                headers: {
                  Authorization: 'Bearer ' + currentToken,
                  source: 'humblebee_admin',
                },
              }
            );
            const apiaries = res.data?.apiary;
            if (Array.isArray(apiaries) && apiaries.length > 0) {
              return { userId, hasApiary: true, apiaries };
            }
          } catch (e) {
            // ignore error
          }
          return null;
        })
      );

      userSurveyApiaryResults.forEach(res => {
        if (res.status === 'fulfilled' && res.value && res.value.hasApiary) {
          const { userId, apiaries } = res.value;
          const isApiaryActive = apiaries.some(a => a.is_active !== false && a.operational_status !== 'Disabled' && a.status !== 'INACTIVE');
          const statusVal = isApiaryActive ? 'Active' : 'Inactive';
          apiaryMap[userId.toString()] = statusVal;
        }
      });

      combinedData = combinedData.map(item => {
        const itemMobile = (item.userInfo?.mobileNumber || item.mobile_number || '').toString().replace(/\D/g, '').slice(-10);
        const itemId = (item.userInfo?._id || item._id || item.id || '').toString();
        const fieldViewId = (item.fieldViewData?.[0]?._id || '').toString();

        const apiaryStatus = apiaryMap[itemMobile] || apiaryMap[itemId] || apiaryMap[fieldViewId] || 'Absent';

        return {
          ...item,
          apiaryStatus
        };
      });


      // In fetchAllProfileData, after setting combinedData:
      console.log("Sample user addresses:", combinedData.slice(0, 5).map(user => ({
        name: user.userInfo?.name,
        state: user.userInfo?.address?.state,
        district: user.userInfo?.address?.district,
        village: user.userInfo?.address?.village,
        block: user.userInfo?.address?.block
      })));

      // Apply cluster filtering if needed
      const urlParams = new URLSearchParams(window.location.search);
      const filterbycluster = urlParams.get('filterbycluster');

      let filteredData = combinedData;
      if (filterbycluster) {
        filteredData = this.filterUserByClusterID(combinedData, filterbycluster);
      }

      console.log("Final filtered data:", {
        total: filteredData.length,
        basic: filteredData.filter(x => x.stage === 'basic').length,
        advance: filteredData.filter(x => x.stage === 'advance').length
      });

      this.setState({
        clusterData: clusterData,
        basicProfiles,
        combinedData: filteredData,
        allData: combinedData, // Store unfiltered data
        allUsers: filteredData,
        filteredUsers: filteredData,
        leadsLoading: false
      }, () => {
        if (isUserRestricted()) {
          this.applyFilters();
        }
      });

    } catch (error) {
      console.error("Error fetching profile data:", error);
      this.setState({ leadsLoading: false });
    }
  };


  componentDidMount() {
    createHost([
      {
        origin: process.env.REACT_APP_CAMPAIGN_URL,
        allowedMethods: ['get', 'set', 'remove'],
      },
    ])

    // Fetch combined profile data
    this.fetchAllProfileData().then(() => {
      // After data is loaded, initialize districts, villages and blocks
      const { districts, villages, blocks } = this.getUniqueLocations(this.state.allData);
      this.setState({
        allDistricts: districts.map(d => ({ name: d })), // Convert to same format as API
        allVillages: villages,
        allBlocks: blocks
      });
    });

    // Keep your other initialization calls
    this.getAllSources();
    this.fetchProjects();
    this.getAllBanks();
  }

  ApiUrl = process.env.REACT_APP_API_APP_FIELD_URL;

  // fetchBasicLeads = async () => {
  //   try {
  //     const response = await axios.get(
  //     `${process.env.REACT_APP_API_APP_FIELD_URL}/surveys/bp/admin-base-profile`,
  //     {
  //       headers: {
  //         source: "humblebee_admin",
  //         Authorization: "Bearer " + JSON.parse(readCookie("access_token")),
  //       },
  //     }
  //   );
  //     console.log("Basic Leads Profile:-", response.data);
  //   } catch (error) {
  //     console.error("Error fetching basic leads:", error);
  //   }
  // };

  // componentDidMount(){ 1
  //   this.fetchBasicLeads();
  // };

  filterUserByClusterID(
    allUser,
    clusterId = false,
    state = false,
    district = false,
    assignedtocluster = false
  ) {
    let users = allUser
    console.log(clusterId)
    if (clusterId?.length > 0) {
      users = users.filter(it => {
        // console.log(it?.userInfo?.fieldViewData?.cluster_id==clusterId,clusterId,it.userInfo?.fieldViewData);
        return it?.fieldViewData[0]?.cluster_id == clusterId
      })
    }
    console.log(users)
    if (state?.length > 0) {
      users = users.filter(it => {
        // console.log(it?.userInfo?.fieldViewData?.cluster_id==clusterId,clusterId,it.userInfo?.fieldViewData);
        return it?.userInfo?.address?.state == state
      })
    }
    if (district?.length > 0) {
      users = users.filter(it => {
        // console.log(it?.userInfo?.fieldViewData?.cluster_id==clusterId,clusterId,it.userInfo?.fieldViewData);
        return district.includes(it?.userInfo?.address?.district?.trim())
      })
    }
    if (assignedtocluster?.length > 0) {
      users = users.filter(it => {
        // console.log(it?.userInfo?.fieldViewData?.cluster_id==clusterId,clusterId,it.userInfo?.fieldViewData);
        return it?.fieldViewData[0]?.cluster_id == clusterId
      })
    }
    this.setState({
      page: 1,
    })
    return users
  }
  componentWillMount() {
    if (JSON.parse(readCookie('userData')).type === 'partners') {
      this.getCreditStats()
    }

    //   ###########################################################################################################################################
    this.getAllSources()
    this.fetchProjects()
    this.getAllBanks()
    if (
      JSON.parse(readCookie('userData')).userType.name ===
      'Project Management Unit' ||
      JSON.parse(readCookie('userData')).userType.name === 'Zonal Manager' ||
      JSON.parse(readCookie('userData')).userType.name === 'Swavalamban Fellows'
    )
      this.setState({ showFollowUpModule: true })

    const res = fetch(
      `${process.env.REACT_APP_API_APP_USER_URL}/user/getAllSurveyedUsers?limit=2000&role=trainee_beekeeper`,
      {
        method: 'GET',
        headers: {
          source: 'humblebee_admin',
          authorization: 'Bearer ' + 'humblbee_admin_token',
        },
      }
    )
      .then(data => data.json())
      .then(async data => {
        console.log('res.data from Users ==> ', data.userInfo[0].userInfo)
        // this.setState({ allUsers: data.userInfo });
        // this.setState({ filteredUsers: this.state.allUsers });

        const urlParams = new URLSearchParams(window.location.search) // Get the query parameters
        console.log(urlParams)

        // Get the value of the parameter 'filterbycluster'
        const filterbycluster = urlParams.get('filterbycluster')
        console.log(filterbycluster)

        let clusterData = await this.getAllClusters()
        let selectedData = data.userInfo
        // console.log(selectedData);

        // console.log(filterbycluster,clusterData);

        selectedData = selectedData.map(item => {
          const cluster = clusterData.find(
            cluster => cluster._id == item?.fieldViewData[0]?.cluster_id
          )
          return {
            ...item, // Keep existing properties
            clusterName: cluster?.clusterName,
            projectName: cluster?.projectId?.name,
          }
        })
        //order the data by item.fieldViewData[0].uodated_at
        selectedData.sort((a, b) => {
          return (
            new Date(b.fieldViewData?.[0]?.updated_at || 0) -
            new Date(a.fieldViewData?.[0]?.updated_at || 0)
          )
        })
        // console.log(selectedData,clusterData);

        let filterdata = selectedData

        if (filterbycluster) {
          filterdata = this.filterUserByClusterID(selectedData, filterbycluster)
        }

        console.log(selectedData, filterdata)

        this.setState({
          clusterData: clusterData,
          allData: selectedData,
          allUsers: filterdata,
          filteredUsers: filterdata,
        }, () => {
          if (isUserRestricted()) {
            this.applyFilters();
          }
        })
      })

    fetch(process.env.REACT_APP_API_URL + '/api/v1/schemes', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allLoanSchemes: data.schemes })
        }
      })

    fetch(process.env.REACT_APP_API_URL + '/api/v1/user/user-types', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allUserTypes: data.userTypes })
        }
      })

    fetch(process.env.REACT_APP_API_URL + '/api/v1/location/states', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          let focusStates = data.data.states.filter(st => st.inFocusRegion)
          focusStates = focusStates.map(st => st.name)
          this.setState({ allStates: data.data.states, focusStates })
        }
      })

    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/user/users/saarthis?type=list&status=Active',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allSaarthis: data.users })
        }
      })

    fetch(
      process.env.REACT_APP_API_URL + '/api/v1/location/districts?sortBy=name',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allDistricts: data.districts })
        }
      })

    if (
      JSON.parse(readCookie('userData')).type === 'le' &&
      (JSON.parse(readCookie('userData')).userType.name ===
        'Project Management Unit' ||
        JSON.parse(readCookie('userData')).userType.name === 'Zonal Manager')
    ) {
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/user/users/swavalamban-fellows?type=list&status=Active&fellowAccessType=Full',
        {
          method: 'GET',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            this.setState({ swavalambanFellows: data.users })
          }
        })
    }
    let getAllLeadsFilter = sessionStorage.getItem('getAllLeadsFilter')
    if (getAllLeadsFilter) {
      if (JSON.parse(getAllLeadsFilter).userType) {
        if (
          JSON.parse(getAllLeadsFilter).userType ===
          'swavalamban-connect-kendra'
        ) {
          fetch(process.env.REACT_APP_API_URL + '/api/v1/ngo', {
            method: 'GET',
            headers: {
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
          })
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                this.setState({ allAssignedTo: data.ngos })
              }
            })
        } else {
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/user/users/' +
            JSON.parse(getAllLeadsFilter).userType,
            {
              method: 'GET',
              headers: {
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                this.setState({ allAssignedTo: data.users })
              }
            })
        }
      }
      this.createBusinessIdeasQuery(JSON.parse(getAllLeadsFilter))
      this.setState({ filterData: JSON.parse(getAllLeadsFilter) }, () => {
        this.submitFilter('searchText')
      })
    } else {
      this.getAllLeads()
      this.createBusinessIdeasQuery(this.state.filterData)
    }
    // this.getFollowUpInfo();
  }


  // 3. CREATE new function to initialize other data
  initializeAllData = () => {
    // Credit stats
    if (JSON.parse(readCookie('userData')).type === 'partners') {
      this.getCreditStats();
    }

    // Sources, projects, banks
    this.getAllSources();
    this.fetchProjects();
    this.getAllBanks();

    // Show follow up module
    if (
      JSON.parse(readCookie('userData')).userType.name === 'Project Management Unit' ||
      JSON.parse(readCookie('userData')).userType.name === 'Zonal Manager' ||
      JSON.parse(readCookie('userData')).userType.name === 'Swavalamban Fellows'
    ) {
      this.setState({ showFollowUpModule: true });
    }

    // Fetch loan schemes
    fetch(process.env.REACT_APP_API_URL + '/api/v1/schemes', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allLoanSchemes: data.schemes });
        }
      });

    // Fetch user types
    fetch(process.env.REACT_APP_API_URL + '/api/v1/user/user-types', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allUserTypes: data.userTypes });
        }
      });

    // Fetch states
    fetch(process.env.REACT_APP_API_URL + '/api/v1/location/states', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          let focusStates = data.data.states.filter(st => st.inFocusRegion);
          focusStates = focusStates.map(st => st.name);
          console.log('Focus States:--', focusStates);
          this.setState({ allStates: data.data.states, focusStates });
        }
      });

    // Fetch saarthis
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/user/users/saarthis?type=list&status=Active',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allSaarthis: data.users });
        }
      });

    // Fetch districts
    fetch(
      process.env.REACT_APP_API_URL + '/api/v1/location/districts?sortBy=name',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allDistricts: data.districts });
        }
      });

    // Fetch swavalamban fellows
    if (
      JSON.parse(readCookie('userData')).type === 'le' &&
      (JSON.parse(readCookie('userData')).userType.name === 'Project Management Unit' ||
        JSON.parse(readCookie('userData')).userType.name === 'Zonal Manager')
    ) {
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/user/users/swavalamban-fellows?type=list&status=Active&fellowAccessType=Full',
        {
          method: 'GET',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            this.setState({ swavalambanFellows: data.users });
          }
        });
    }
  };



  getAllBanks = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/v1/bank-branches/banks', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allBanks: data.allBanks })
        }
      })
  }
  getAllSources = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/v1/lists/sources', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allSources: data.sources })
        }
      })
  }

  getAllLeads = (query, cb, selectMode) => {
    this.setState({ leadsLoading: true })
    if (!query)
      query = `?pageNumber=${this.state.page - 1}&limit=${this.state.sizePerPage
        }&disqualified=${this.state.filterData.disqualified}&starred=${this.state.filterData.starred
        }&onHold=${this.state.filterData.onHold}`
    // if(this.props.sidebarMinimized) query += `&capitalFulfilledStage=${this.state.filterData.capitalFulfilledStage}&enterpriseSetupStage=${this.state.filterData.enterpriseSetupStage}`;
    // fetch(
    //   process.env.REACT_APP_API_URL + "/api/v1/swati-leads/counts" + query,
    //   {
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": JSON.parse(readCookie("access_token")),
    //     },
    //   }
    // )
    //   .then((data) => data.json())
    //   .then((data) => {
    //     if (data.status) {
    //       this.setState({ leadCounts: data.leadCounts });
    //     }
    //   });
    // fetch(
    //   process.env.REACT_APP_API_URL +
    //   "/api/v1/swati-leads/followup-counts" +
    //   query,
    //   {
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": JSON.parse(readCookie("access_token")),
    //     },
    //   }
    // )
    //   .then((data) => data.json())
    //   .then((data) => {
    //     if (data.status) {
    //       this.setState({ followUpCounts: data.followUpCounts });
    //     }
    //   });

    query += `&dueToday=${this.state.followUpFilters.today}&dueThisWeek=${this.state.followUpFilters.week}&overDue=${this.state.followUpFilters.overDue}`
    let path = process.env.REACT_APP_API_URL + '/api/v1/swati-leads/all-in-one'
    if (
      this.props.type === 'swavalamban-connect-kendra' &&
      this.props.view === 'tab'
    )
      path =
        process.env.REACT_APP_API_URL +
        '/api/v1/swati-leads/' +
        this.props.orgId
    fetch(
      // process.env.REACT_APP_API_URL + "/api/v1/swati-leads/all-in-one" + query,
      path + query,
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          let filterData = this.state.filterData
          let selectedIdea = this.state.filterData.idea
          if (selectedIdea) {
            let hasIdea = false
            for (let i = 0; i < data.ideas.length; i++) {
              if (data.ideas[i].combine === selectedIdea) hasIdea = true
            }
            if (!hasIdea) filterData['idea'] = ''
            this.setState({ filterData })
          }
          this.setState(
            {
              allLeads: data.simpleLeadInfo || [],
              selectAllLeadsInfo: data.selectAllLeadsInfo || [],
              totalLeads: data.totalLeads || 0,
              followUpDues: data.records || [],
              leadCounts: data.leadCounts || {},
              followUpCounts: data.followUpCounts || {},
              allBusinessIdeas: data.ideas || [],
              allSupportServices: data.allSupportServices || [],
              leadsLoading: false,
              allMilestones: data.milestones || [],
            },
            () => {
              $(() => {
                // use UI arrows in page content to control scrolling
                this.scrolling = false
                // var that = this;

                $('#drag-table-left').mouseover(evt => {
                  this.scrolling = true
                  this.startScrolling(
                    $('table#leads-page-table.table'),
                    8,
                    evt.target.id,
                    'right'
                  )
                })

                $('#drag-table-right').mouseover(evt => {
                  this.scrolling = true
                  this.startScrolling(
                    $('table#leads-page-table.table'),
                    8,
                    evt.target.id,
                    'left'
                  )
                })

                $('#drag-table-left').mouseout(() => {
                  this.scrolling = false
                })
                $('#drag-table-right').mouseout(() => {
                  this.scrolling = false
                })
              })
            }
          )
        }
      })
    // fetch(path, {
    //   method: "GET",
    //   headers: {
    //     "x-auth-token": JSON.parse(readCookie("access_token")),
    //   },
    // })
    //   .then((data) => data.json())
    //   .then((data) => {
    //     if (cb) cb();
    //     if (data.status) {
    //       this.setState(
    //         {
    //           allLeads: data.simpleLeadInfo,
    //           totalLeads: data.totalLeads,
    //           followUpDues: data.records,
    //         },
    //         () => {
    //           $(() => {
    //             // use UI arrows in page content to control scrolling
    //             this.scrolling = false;
    //             // var that = this;

    //             $("#drag-table-left").mouseover((evt) => {
    //               this.scrolling = true;
    //               this.startScrolling(
    //                 $("table#leads-page-table.table"),
    //                 8,
    //                 evt.target.id,
    //                 "right"
    //               );
    //             });

    //             $("#drag-table-right").mouseover((evt) => {
    //               this.scrolling = true;
    //               this.startScrolling(
    //                 $("table#leads-page-table.table"),
    //                 8,
    //                 evt.target.id,
    //                 "left"
    //               );
    //             });

    //             $("#drag-table-left").mouseout(() => {
    //               this.scrolling = false;
    //             });
    //             $("#drag-table-right").mouseout(() => {
    //               this.scrolling = false;
    //             });
    //           });
    //         }
    //       );
    //     }
    //   });
  }

  changeFilterHandlerHumblebee = (filterType, value) => {
    console.log('changeFilterHandler', filterType, value)
    this.setState(
      prevState => ({
        filterData: {
          ...prevState.filterData,
          [filterType]: value,
        },
      }),
      this.applyFilters // Call applyFilters after state update
    )
  }

  // 4. FIX: Update applyFilters function
  applyFilters = () => {
    const { state, district, assignedToCluster, stage, village, srlm_associated, apiaryStatus, block, clusterName, projectName, gender, landOwnerShip, practiceBeekeeping, trainedinBeekeepingProgram, interestedinMoreBeeBoxes, useChemical, ownCattle, education, reportedBy } = this.state.filterData;

    let filteredUsers = this.state.allData || []; // Use allData instead of allUsers

    console.log('Applying filters:', {
      state,
      district,
      village,
      block,
      clusterName,
      stage,
      srlm_associated,
      projectName,
      gender
    });

    // Apply stage filter
    if (stage) {
      filteredUsers = filteredUsers.filter(user => user.stage === stage);
    }

    // Apply state filter - Check both basic and advance stage locations
    if (state) {
      filteredUsers = filteredUsers.filter(user => {
        // For basic stage: check userInfo.address.state
        const basicStageState = user.userInfo?.address?.state || '';

        // For advance stage: check surveyData.stages[0].form_data.state
        const advanceStageState = user.surveyData?.stages?.[0]?.form_data?.state || '';

        // Effective state displayed on table (basicStageState takes precedence if available)
        const effectiveState = (basicStageState || advanceStageState).trim();
        return effectiveState === state;
      });
    }

    // Apply project name filter (NEW)
    if (projectName && projectName.length > 0) {
      filteredUsers = filteredUsers.filter(user => {
        const userProjectName = user.projectName || '';
        return userProjectName && projectName.includes(userProjectName);
      });
    }

    // Apply gender filter
    if (gender) {
      filteredUsers = filteredUsers.filter(user => {
        const userGender = user.userInfo?.gender || '';
        return userGender === gender;
      });
    }

    // Apply district filter - Check both basic and advance stage locations
    if (district && district.length > 0) {
      filteredUsers = filteredUsers.filter(user => {
        // For basic stage: check userInfo.address.district
        const basicStageDistrict = user.userInfo?.address?.district || '';

        // For advance stage: check surveyData.stages[0].form_data.district
        const advanceStageDistrict = user.surveyData?.stages?.[0]?.form_data?.district || '';

        // Effective district displayed on table
        const effectiveDistrict = (basicStageDistrict || advanceStageDistrict).trim();
        return district.includes(effectiveDistrict);
      });
    }

    // Apply village filter - Check both basic and advance stage locations
    if (village && village.length > 0) {
      filteredUsers = filteredUsers.filter(user => {
        // For basic stage: check userInfo.address.village
        const basicStageVillage = user.userInfo?.address?.village || '';

        // For advance stage: check surveyData.stages[0].form_data.village
        const advanceStageVillage = user.surveyData?.stages?.[0]?.form_data?.village || '';

        // Effective village displayed on table
        const effectiveVillage = (basicStageVillage || advanceStageVillage).trim();
        return effectiveVillage && village.includes(effectiveVillage);
      });
    }

    // Apply block filter - Check both basic and advance stage locations
    if (block && block.length > 0) {
      filteredUsers = filteredUsers.filter(user => {
        // For basic stage: check userInfo.address.block
        const basicStageBlock = user.userInfo?.address?.block || '';

        // For advance stage: check surveyData.stages[0].form_data.block
        const advanceStageBlock = user.surveyData?.stages?.[0]?.form_data?.block || '';

        // Effective block displayed on table
        const effectiveBlock = (basicStageBlock || advanceStageBlock).trim();
        return effectiveBlock && block.includes(effectiveBlock);
      });
    }

    // Apply SRLM filter (NEW)
    if (srlm_associated !== '') {
      const srlmValue = srlm_associated === 'true';
      filteredUsers = filteredUsers.filter(user => {
        return user.srlm_associated === srlmValue;
      });
    }

    // Apply Apiary Status filter
    if (apiaryStatus) {
      filteredUsers = filteredUsers.filter(user => {
        return user.apiaryStatus === apiaryStatus;
      });
    }

    // Apply cluster filter
    if (assignedToCluster) {
      filteredUsers = filteredUsers.filter(user => {
        const userCluster = user.fieldViewData?.[0]?.cluster_id || '';
        return userCluster === assignedToCluster;
      });
    }

    // Helper to safely extract a field value from a specific survey stage
    const getSurveyFieldValue = (user, stageName, fieldName) => {
      const stages = user.surveyData?.stages;
      if (!Array.isArray(stages)) return '';
      const stageObj = stages.find(s => s.stage_name === stageName);
      return stageObj?.form_data?.[fieldName] || '';
    };

    // Apply Land Ownership filter
    if (landOwnerShip) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'financialOverview', 'landOwnership') || user.landOwnerShip || '';
        return val === landOwnerShip;
      });
    }



    // Apply Practice Beekeeping filter
    if (practiceBeekeeping) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'beekeepingScope', 'practiceBeekeeping') || '';
        return val === practiceBeekeeping;
      });
    }

    // Apply Beekeeping Training filter
    if (trainedinBeekeepingProgram) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'beekeepingScope', 'trainedinBeekeepingProgram') || '';
        return val === trainedinBeekeepingProgram;
      });
    }

    // Apply Box Interest filter
    if (interestedinMoreBeeBoxes) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'beekeepingScope', 'interestedinMoreBeeBoxes') || '';
        return val === interestedinMoreBeeBoxes;
      });
    }

    // Apply Chemical Pesticides filter
    if (useChemical) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'cultivationDetails', 'useOfPesticides') || '';
        return val === useChemical;
      });
    }

    // Apply Livestock Owner filter
    if (ownCattle) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'financialOverview', 'ownCattles') || '';
        return val === ownCattle;
      });
    }

    // Apply Education Level filter
    if (education) {
      filteredUsers = filteredUsers.filter(user => {
        const val = getSurveyFieldValue(user, 'candidateProfile', 'education') || user.userInfo?.education || '';
        return val === education;
      });
    }

    // Apply Reported By / Surveyed By filter
    if (reportedBy && (Array.isArray(reportedBy) ? reportedBy.length > 0 : reportedBy !== '')) {
      filteredUsers = filteredUsers.filter(user => {
        const surveyor = user.surveyorName || '';
        return Array.isArray(reportedBy)
          ? reportedBy.includes(surveyor)
          : surveyor === reportedBy;
      });
    }

    // console.log('Filtered result:', filteredUsers.length);
    // console.log('Sample filtered users:', JSON.stringify(filteredUsers.map( ele => ele.surveyData?.stages[0]?.form_data)));

    // Update state
    this.setState({
      filteredUsers,
      allUsers: filteredUsers,
      page: 1 // Reset to first page when filtering
    });
  };

  // applyFilters = () => { old
  //   const { state, district, assignedToCluster, stage } = this.state.filterData
  //   console.log('Applying filters', { state, district, assignedToCluster, stage })

  //   // Filter `allUsers` based on selected filters
  //   const filteredUsers = this.state.allUsers.filter(user => {
  //     // user fields may be nested under userInfo; support both shapes
  //     const userState = user.state || user.userInfo?.address?.state || ''
  //     const userDistrict = user.district || user.userInfo?.address?.district || ''
  //     const userCluster = user.assignedToCluster || user.userInfo?.assignedToCluster || ''
  //     const userStage = user.stage || user.userInfo?.stage || ''

  //     const stateMatch = !state || userState === state
  //     const districtMatch = !district || district.length === 0 || district.includes(userDistrict)
  //     const clusterMatch = !assignedToCluster || userCluster === assignedToCluster
  //     const stageMatch = !stage || userStage === stage

  //     return stateMatch && districtMatch && clusterMatch && stageMatch
  //   })

  //   // Update filtered users in state
  //   this.setState({ filteredUsers, 
  //      allUsers: filteredUsers // Update allUsers for pagination
  //   })
  // }

  selectAllLeads = e => {
    if (!e.target.checked) {
      this.setState({ selectMode: false })
      this.setState({
        allLeadsSelected: false,
        selectedLeads: [],
        selectedLeadsIds: [],
      })
      this.setState({ selectMode: true })
    } else {
      this.setState({ selectMode: false })
      this.setState({
        allLeadsSelected: true,
        selectedLeads: this.state.selectAllLeadsInfo || [],
        selectedLeadsIds: this.state.selectAllLeadsInfo.map(x => x._id) || [],
      })
      this.setState({ selectMode: true })
    }
    // if (!query)
    //   query = `?pageNumber=${this.state.page - 1}&limit=${this.state.sizePerPage
    //     }&disqualified=${this.state.filterData.disqualified}&starred=${this.state.filterData.starred
    //     }&onHold=${this.state.filterData.onHold}`;

    // query += `&dueToday=${this.state.followUpFilters.today}&dueThisWeek=${this.state.followUpFilters.week}&overDue=${this.state.followUpFilters.overDue}`;
    // let path =
    //   process.env.REACT_APP_API_URL + "/api/v1/swati-leads/selectall";
    // fetch(
    //   path + query,
    //   {
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": JSON.parse(readCookie("access_token")),
    //     },
    //   }
    // )
    //   .then((data) => data.json())
    //   .then((data) => {
    //     if (this.state.allLeadsSelected) {
    //       this.setState({selectMode: false})
    //       this.setState({allLeadsSelected: false, selectedLeads: []})
    //       this.setState({selectMode: true})
    //     } else {
    //       this.setState({selectMode: false})
    //       this.setState({allLeadsSelected: true, selectedLeads: data.simpleLeadInfo})
    //       this.setState({selectMode: true})
    //     }
    //   })
  }

  getAllBusinessIdeas = (query, selectedIdea) => {
    // fetch(
    //   process.env.REACT_APP_API_URL +
    //   "/api/v1/swati-leads/lead-business-ideas" +
    //   query,
    //   {
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": JSON.parse(readCookie("access_token")),
    //     },
    //   }
    // )
    //   .then((data) => data.json())
    //   .then((data) => {
    //     if (data.status) {
    //       let filterData = this.state.filterData;
    //       if (selectedIdea) {
    //         let hasIdea = false;
    //         for (let i = 0; i < data.ideas.length; i++) {
    //           if (data.ideas[i].combine === selectedIdea) hasIdea = true;
    //         }
    //         if (!hasIdea) filterData["idea"] = "";
    //         this.setState({ filterData });
    //       }
    //       this.setState({ allBusinessIdeas: data.ideas });
    //     }
    //   });
  }

  startScrolling = (obj, spd, btn, direction) => {
    var travelX = 0,
      stop = false
    if ($(obj).css('transform') !== 'none')
      travelX = parseInt($(obj).css('transform').split(',')[4].trim())

    if (direction === 'left') {
      let max =
        $('.leads-table-container .react-bootstrap-table').width() -
        $(obj).width()
      if (travelX - spd < max) {
        travelX = max
        stop = true
        $(obj).css('transform', 'translateX(' + travelX + 'px)')
      } else travelX -= spd
    } else if (direction === 'right') {
      if (travelX + spd > 0) {
        travelX = 0
        stop = true
        $(obj).css('transform', 'translateX(' + travelX + 'px)')
      } else travelX += spd
    }

    if (!this.scrolling || stop) {
      obj.stop()
    } else {
      $(obj).css('transform', 'translateX(' + travelX + 'px)')
      // recursively call startScrolling while mouse is hovered
      setTimeout(() => {
        this.startScrolling(obj, spd, btn, direction)
      }, spd)
    }
  }

  resetFilter = () => {
    //reset this.state.filteredUsers
    const isRestricted = isUserRestricted();
    let defaultProjectName = [];
    if (isRestricted) {
      const defaultName = getDefaultProjectFilterName(this.state.projects);
      if (defaultName) {
        defaultProjectName = [defaultName];
      }
    }

    this.setState({
      allUsers: this.state.allData,
      filterData: {
        ...this.state.filterData,
        clusterName: null,
        district: [],
        village: [],        // Reset
        block: [],          // Reset
        srlm_associated: "",
        apiaryStatus: "",
        state: '',
        page: 1,
        projectName: defaultProjectName,    // Reset project name or default it
        gender: '',        // Reset gender
        reportedBy: [],
      },
      searchText: '',
      filteredUsers: [],
    })

    fetch(
      process.env.REACT_APP_API_URL + '/api/v1/location/districts?sortBy=name',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allDistricts: data.districts })
        }
      })

    let filterData = {
      loanScheme: [],
      loanSchemeId: [],
      paymentClaim: '',
      essOptedFor: '',
      scaleUpQuestionnaire: '',
      bplanAge: '',
      pwd: '',
      idea: '',
      phase: '',
      audit: '',
      entrepreneurStoryVerification: '',
      gender: '',
      category: '',
      state: '',
      district: [],
      cluster: [],
      fromDate: null,
      toDate: null,
      hasComments: '',
      businessPlanVerification: '',
      collateral: '',
      bankAccounts: [],
      financeType: '',
      minLoanAmount: '',
      maxLoanAmount: '',
      userType: '',
      assignedTo: '',
      taggedTo: '',
      overallSentiment: '',
      strengthRating: '',
      maturityStatus: [],
      capitalFulfilledStatus: [],
      filedIncomeTax: '',
      modeOfApplication: '',
      disqualified: false,
      starred: false,
      onHold: false,
      profilingStage: false,
      dueDiligenceStage: false,
      businessPlanStage: false,
      capitalFulfilledStage: false,
      enterpriseSetupStage: false,
      tentativeHorizonToCloseThis: '',
      enterpriseSustainabilityStage: false,
      sidbiMilestone: '',
      // NEW FILTERS RESET
      landOwnerShip: '',
      practiceBeekeeping: '',
      trainedinBeekeepingProgram: '',
      interestedinMoreBeeBoxes: '',
      useChemical: '',
      ownCattle: '',
      education: '',
      srlm_associated: '',
      apiaryStatus: '',
      village: [],
      block: [],
      reportedBy: [],
    }

    if (isRestricted && defaultProjectName.length > 0) {
      filterData.projectName = defaultProjectName;
    }

    let query = `?pageNumber=${this.state.page - 1}&limit=${this.state.sizePerPage
      }&disqualified=false&starred=false&onHold=false`

    sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))

    this.setState({ filterData, allAssignedTo: [] }, () =>
      this.getAllLeads(query)
    )
    this.createBusinessIdeasQuery(filterData)
    // this.showFilter();
  }
  notifySuccess = text => toast.success(text)

  submitFilter = (
    type = '',
    page = this.state.page,
    sizePerPage = this.state.sizePerPage,
    searchText = this.state.searchText,
    sortBy = '',
    sortOrder = ''
  ) => {
    let filterData = this.state.filterData,
      query = `?pageNumber=${page - 1}&limit=${sizePerPage}`

    if (searchText) query += `&q=${searchText}`
    if (
      filterData.loanScheme &&
      filterData.loanSchemeId.length &&
      filterData.loanSchemeId[0]
    )
      query += '&loanSchemeId=' + filterData.loanSchemeId.join(',')
    if (filterData.pwd !== '' && filterData.pwd !== undefined)
      query += `&pwd=${filterData.pwd}`
    if (filterData.idea !== '' && filterData.idea !== undefined)
      query += `&idea=${filterData.idea}`
    if (filterData.phase !== '' && filterData.phase !== undefined)
      query += `&phase=${filterData.phase}`
    if (filterData.paymentClaim !== '' && filterData.paymentClaim !== undefined)
      query += `&paymentClaim=${filterData.paymentClaim}`
    if (filterData.essOptedFor !== '' && filterData.essOptedFor !== undefined)
      query += `&essOptedFor=${filterData.essOptedFor}`
    if (
      filterData.scaleUpQuestionnaire !== '' &&
      filterData.scaleUpQuestionnaire !== undefined
    )
      query += `&scaleUpQuestionnaire=${filterData.scaleUpQuestionnaire}`
    if (filterData.audit !== '' && filterData.audit !== undefined)
      query += `&audit=${filterData.audit}`
    if (
      filterData.entrepreneurStoryVerification !== '' &&
      filterData.entrepreneurStoryVerification !== undefined
    )
      query += `&entrepreneurStoryVerification=${filterData.entrepreneurStoryVerification}`
    if (filterData.state !== '' && filterData.state !== undefined)
      query += `&state=${filterData.state}`
    if (filterData.stage && filterData.stage !== '') query += `&stage=${filterData.stage}`
    if (filterData.gender !== '' && filterData.gender !== undefined)
      query += `&gender=${filterData.gender}`
    if (filterData.category !== '' && filterData.category !== undefined)
      query += `&category=${filterData.category}`
    if (filterData.collateral !== '' && filterData.collateral !== undefined)
      query += `&collateral=${filterData.collateral}`
    if (filterData.hasComments !== '' && filterData.hasComments !== undefined)
      query += `&hasComments=${filterData.hasComments}`
    if (
      filterData.businessPlanVerification !== '' &&
      filterData.businessPlanVerification !== undefined
    )
      query += `&businessPlanVerification=${filterData.businessPlanVerification}`
    if (
      filterData.bankAccounts &&
      filterData.bankAccounts.length &&
      filterData.bankAccounts[0]
    )
      query += `&bankAccounts=${filterData.bankAccounts.join(',')}`
    if (filterData.source && filterData.source !== '')
      query += `&source=${filterData.source}`
    if (
      filterData.district &&
      filterData.district.length &&
      filterData.district[0]
    )
      query += `&district=${filterData.district.join(',')}`
    if (filterData.toDate)
      query += `&toDate=${moment(filterData.toDate).format('DD-MM-YYYY')}`
    if (filterData.fromDate)
      query += `&fromDate=${moment(filterData.fromDate).format('DD-MM-YYYY')}`
    if (filterData.financeType !== '' && filterData.financeType !== undefined)
      query += `&financeType=${encodeURIComponent(filterData.financeType)}`
    if (
      filterData.overallSentiment !== '' &&
      filterData.overallSentiment !== undefined
    )
      query += `&overallSentiment=${filterData.overallSentiment}`
    if (
      filterData.strengthRating !== '' &&
      filterData.strengthRating !== undefined
    )
      query += `&strengthRating=${filterData.strengthRating}`
    if (
      filterData.filedIncomeTax !== '' &&
      filterData.filedIncomeTax !== undefined
    )
      query += `&filedIncomeTax=${filterData.filedIncomeTax}`
    if (
      filterData.modeOfApplication !== '' &&
      filterData.modeOfApplication !== undefined
    )
      query += `&modeOfApplication=${filterData.modeOfApplication}`
    if (filterData.disqualified !== '' && filterData.disqualified !== undefined)
      query += `&disqualified=${filterData.disqualified}`
    if (filterData.starred !== '' && filterData.starred !== undefined)
      query += `&starred=${filterData.starred}`
    if (filterData.onHold !== '' && filterData.onHold !== undefined)
      query += `&onHold=${filterData.onHold}`
    if (filterData.profilingStage && filterData.profilingStages.length)
      query += `&profilingStages=${filterData.profilingStages}`
    if (filterData.dueDiligenceStage && filterData.dueDiligenceStages.length)
      query += `&dueDiligenceStages=${filterData.dueDiligenceStages}`
    if (filterData.businessPlanStage && filterData.businessPlanStages.length)
      query += `&businessPlanStages=${filterData.businessPlanStages}`
    if (
      filterData.capitalFulfilledStage &&
      filterData.capitalFulfilledStages.length
    )
      query += `&capitalFulfilledStages=${filterData.capitalFulfilledStages}`
    if (
      filterData.enterpriseSetupStage &&
      filterData.enterpriseSetupStages.length
    )
      query += `&enterpriseSetupStages=${filterData.enterpriseSetupStages}`
    if (
      filterData.dueDiligenceStages &&
      filterData.dueDiligenceStages.indexOf('Hold') > -1 &&
      filterData.ddOnHoldReasons &&
      filterData.ddOnHoldReasons.length
    )
      query += `&ddOnHoldReasons=${filterData.ddOnHoldReasons.join('|')}`
    if (
      filterData.businessPlanStages &&
      filterData.businessPlanStages.indexOf('Hold') > -1 &&
      filterData.bpOnHoldReasons &&
      filterData.bpOnHoldReasons.length
    )
      query += `&bpOnHoldReasons=${filterData.bpOnHoldReasons.join('|')}`
    if (
      filterData.enterpriseSustainabilityStage &&
      filterData.enterpriseSustainabilityStages.length
    )
      query += `&enterpriseSustainabilityStages=${filterData.enterpriseSustainabilityStages}`
    if (
      filterData.disqualified &&
      filterData.disqualificationReasons &&
      filterData.disqualificationReasons.length
    )
      query += `&disqualificationReasons=${filterData.disqualificationReasons.join(
        '|'
      )}`
    if (
      filterData.tentativeHorizonToCloseThis !== '' &&
      filterData.tentativeHorizonToCloseThis !== undefined
    )
      query += `&tentativeHorizonToCloseThis=${filterData.tentativeHorizonToCloseThis}`
    if (filterData.maturityStatus.length && filterData.maturityStatus[0])
      query += `&maturityStatus=${filterData.maturityStatus.join(',')}`
    if (
      filterData.capitalFulfilledStatus &&
      filterData.capitalFulfilledStatus.length &&
      filterData.capitalFulfilledStatus[0]
    )
      query += `&capitalFulfilledStatus=${filterData.capitalFulfilledStatus.join(
        ','
      )}`
    if (type === 'sort' && sortBy && sortOrder)
      query += `&sortBy=${sortBy}&sortOrder=${sortOrder}`
    if (filterData.userType) query += `&userType=${filterData.userType}`
    if (filterData.assignedTo) query += `&assignedTo=${filterData.assignedTo}`
    if (filterData.taggedTo) query += `&taggedTo=${filterData.taggedTo}`
    if (filterData.minLoanAmount)
      query += `&minLoanAmount=${filterData.minLoanAmount}`
    if (filterData.maxLoanAmount)
      query += `&maxLoanAmount=${filterData.maxLoanAmount}`

    // infographic filters
    if (filterData.bPlanCompleted)
      query += `&bPlanCompleted=${filterData.bPlanCompleted}`
    if (filterData.loanAppApplied)
      query += `&loanAppApplied=${filterData.loanAppApplied}`
    if (filterData.eSetupInProgress)
      query += `&eSetupInProgress=${filterData.eSetupInProgress}`
    if (filterData.bplanAge) query += `&bplanAge=${filterData.bplanAge}`
    if (filterData.sidbiMilestone)
      query += `&milestone=${filterData.sidbiMilestone}`

    if (
      type !== 'page' &&
      type !== 'sizePerPage' &&
      type !== 'searchText' &&
      type !== 'sort'
    )
      this.showFilter()
    this.setState({ selectAllLeadsQuery: query })
    this.getAllLeads(query)
  }

  // changeStateFilter = e => {
  //   let filterData = this.state.filterData
  //   filterData['state'] = e
  //   if (e) {

  //     filterData['district'] = []
  //     fetch(
  //       process.env.REACT_APP_API_URL +
  //         '/api/v1/location/get-address?stateId=' +
  //         e,
  //       {
  //         method: 'GET',
  //         headers: {
  //           'x-auth-token': JSON.parse(readCookie('access_token')),
  //         },
  //       }
  //     )
  //       .then(data => data.json())
  //       .then(data => {
  //         if (data.status) {
  //           this.setState({ allDistricts: data.districts })
  //         }
  //       })
  //   } else {
  //     fetch(
  //       process.env.REACT_APP_API_URL +
  //         '/api/v1/location/districts?sortBy=name',
  //       {
  //         method: 'GET',
  //         headers: {
  //           'x-auth-token': JSON.parse(readCookie('access_token')),
  //         },
  //       }
  //     )
  //       .then(data => data.json())
  //       .then(data => {
  //         if (data.status) {
  //           this.setState({ allDistricts: data.districts })
  //         }
  //       })
  //   }
  //   sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
  //   this.createBusinessIdeasQuery(filterData)
  //   this.setState({ filterData }, () => {
  //      this.applyFilters(); // Use applyFilters instead of submitFilter
  //   })
  // }

  changeStateFilter = e => {
    let filterData = this.state.filterData;
    filterData['state'] = e;

    // Reset cascading filters when state changes
    filterData['district'] = [];
    filterData['block'] = [];
    filterData['village'] = [];

    if (e) {
      // Get districts, villages and blocks filtered by the selected state from data
      const { districts, villages, blocks } = this.getUniqueLocations(
        this.state.allData,
        e,
        [] // empty district array since we just reset it
      );

      this.setState({
        allDistricts: districts.map(d => ({ name: d })), // Convert to same format as API
        allVillages: [], // Clear villages until district is selected
        allBlocks: [], // Clear blocks until district is selected
        filterData
      }, () => {
        this.applyFilters();
      });
    } else {
      // Reset to all locations when no state selected
      const { districts, villages, blocks } = this.getUniqueLocations(this.state.allData, '', []);

      this.setState({
        allDistricts: districts.map(d => ({ name: d })),
        allVillages: villages,
        allBlocks: blocks,
        filterData
      }, () => {
        this.applyFilters();
      });
    }
  };

  // New function to handle district filter changes
  changeDistrictFilter = (selectedDistricts) => {
    let filterData = this.state.filterData;
    filterData['district'] = selectedDistricts;

    // Reset block and village when district changes
    filterData['block'] = [];
    filterData['village'] = [];

    if (selectedDistricts && selectedDistricts.length > 0) {
      // Get villages and blocks filtered by state and selected district(s)
      const { villages, blocks } = this.getUniqueLocations(
        this.state.allData,
        this.state.filterData.state,
        selectedDistricts
      );

      this.setState({
        allVillages: villages,
        allBlocks: blocks,
        filterData
      }, () => {
        this.applyFilters();
      });
    } else {
      // If no districts selected, show all villages/blocks for the selected state
      const { villages, blocks } = this.getUniqueLocations(
        this.state.allData,
        this.state.filterData.state,
        []
      );

      this.setState({
        allVillages: villages,
        allBlocks: blocks,
        filterData
      }, () => {
        this.applyFilters();
      });
    }
  };

  changeFilterHandler = async (type, e) => {
    let filterData = this.state.filterData,
      value = ''
    if (e && e.hasOwnProperty('target')) value = e.target.value
    else value = e
    if (type === 'fromToDate') {
      filterData['fromDate'] = e[0]
      filterData['toDate'] = e[1]
    } else if (type === 'loanSchemes') {
      filterData['loanSchemeId'] = e
      if (e && e.length) {
        filterData['loanScheme'] = this.state.allLoanSchemes.filter(
          scheme => e.indexOf(scheme._id) > -1
        )
      } else {
        filterData['loanScheme'] = []
      }
    } else if (
      type === 'disqualified' ||
      type === 'starred' ||
      type === 'onHold' ||
      type === 'profilingStage' ||
      type === 'dueDiligenceStage' ||
      type === 'businessPlanStage' ||
      type === 'capitalFulfilledStage' ||
      type === 'enterpriseSetupStage' ||
      type === 'enterpriseSustainabilityStage'
    ) {
      if (type === 'profilingStage') {
        if (!filterData[type]) {
          filterData['profilingStages'] = ['Basic', 'Advanced']
        } else {
          filterData['profilingStages'] = []
        }
      } else if (type === 'dueDiligenceStage') {
        if (!filterData[type]) {
          filterData['dueDiligenceStages'] = ['Not Started', 'Pending', 'Hold']
          filterData['ddOnHoldReasons'] = JSON.parse(
            JSON.stringify(this.state.ddOnHoldReasons)
          )
        } else {
          filterData['dueDiligenceStages'] = []
          filterData['ddOnHoldReasons'] = []
        }
      } else if (type === 'businessPlanStage') {
        if (!filterData[type]) {
          filterData['businessPlanStages'] = ['Not Started', 'Pending', 'Hold']
          filterData['bpOnHoldReasons'] = JSON.parse(
            JSON.stringify(this.state.bpOnHoldReasons)
          )
        } else {
          filterData['businessPlanStages'] = []
          filterData['bpOnHoldReasons'] = []
        }
      } else if (type === 'capitalFulfilledStage') {
        if (!filterData[type]) {
          filterData['capitalFulfilledStages'] = [
            'Not Started',
            'Sanctioned',
            'Applied',
            'Rejected',
          ] // 'Disbursed', 'Not required'
        } else {
          filterData['capitalFulfilledStages'] = []
        }
      } else if (type === 'enterpriseSetupStage') {
        if (!filterData[type]) {
          filterData['enterpriseSetupStages'] = [
            'Not Started',
            'Started up',
            'Scaled up',
          ]
        } else {
          filterData['enterpriseSetupStages'] = []
        }
      } else if (type === 'enterpriseSustainabilityStage') {
        if (!filterData[type]) {
          filterData['enterpriseSustainabilityStages'] = [
            'Not Started',
            'Operational',
            'Not Operational',
            'Halted',
            'Pivoted',
          ]
        } else {
          filterData['enterpriseSustainabilityStages'] = []
        }
      } else if (type === 'disqualified') {
        if (!filterData[type])
          filterData['disqualificationReasons'] = JSON.parse(
            JSON.stringify(this.state.disqualificationReasons)
          )
        else filterData['disqualificationReasons'] = []
      }
      filterData[type] = !filterData[type]
    } else if (
      type === 'district' ||
      type === 'maturityStatus' ||
      type === 'capitalFulfilledStatus'
    ) {
      if (value.indexOf('') > -1) filterData[type] = ['']
      else filterData[type] = value
    } else if (type === 'cluster') {
      for (let i = 0; i < this.state.swavalambanFellows.length; i++) {
        if (value.includes(this.state.swavalambanFellows[i]._id)) {
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/location/get-address?stateId=' +
            this.state.swavalambanFellows[i].state[0],
            {
              method: 'GET',
              headers: {
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                filterData['cluster'] = value
                this.setState({ allDistricts: data.districts })
                filterData['state'] = this.state.swavalambanFellows[i].state[0]
                filterData['district'] =
                  this.state.swavalambanFellows[i].district
                sessionStorage.setItem(
                  'getAllLeadsFilter',
                  JSON.stringify(filterData)
                )
                this.createBusinessIdeasQuery(filterData)
                this.setState({ filterData }, () => {
                  this.submitFilter('searchText')
                })
              }
            })
        }
      }
    } else if (type === 'userType' && value === 'swavalamban-connect-kendra') {
      filterData['assignedTo'] = ''
      filterData['userType'] = value
      fetch(process.env.REACT_APP_API_URL + '/api/v1/ngo', {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      })
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            this.setState({ allAssignedTo: data.ngos })
            sessionStorage.setItem(
              'getAllLeadsFilter',
              JSON.stringify(filterData)
            )
            this.createBusinessIdeasQuery(filterData)
            this.setState({ filterData }, () => {
              this.submitFilter('searchText')
            })
          }
        })
    } else if (type === 'userType' && value) {
      filterData['assignedTo'] = ''
      filterData['userType'] = value
      if (value !== 'Unassigned') {
        fetch(process.env.REACT_APP_API_URL + '/api/v1/user/users/' + value, {
          method: 'GET',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
        })
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              this.setState({ allAssignedTo: data.users })
              sessionStorage.setItem(
                'getAllLeadsFilter',
                JSON.stringify(filterData)
              )
              this.createBusinessIdeasQuery(filterData)
              this.setState({ filterData }, () => {
                this.submitFilter('searchText')
              })
            }
          })
      } else {
        sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
        this.createBusinessIdeasQuery(filterData)
        this.setState({ filterData }, () => {
          this.submitFilter('searchText')
        })
      }
    } else if (type === 'userType' && !value) {
      filterData['userType'] = ''
      filterData['assignedTo'] = ''
      sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
      this.createBusinessIdeasQuery(filterData)
      this.setState({ filterData }, () => {
        this.submitFilter('searchText')
      })
    }
    // follow up filters
    else if (type === 'followUp') {
      var followUpFilters = { ...this.state.followUpFilters }
      followUpFilters[e.target.name] = !followUpFilters[e.target.name]
      this.setState({ followUpFilters })
    } else {
      filterData[type] = value
    }

    if (type !== 'cluster' && type !== 'userType') {
      sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
      this.createBusinessIdeasQuery(filterData)
      this.setState({ filterData }, () => {
        this.submitFilter('searchText')
      })
    }
  }

  changeSubFilterHandler = (type, value) => {
    let filterData = this.state.filterData

    if (filterData[type].indexOf(value) > -1) {
      filterData[type].splice(filterData[type].indexOf(value), 1)
      if (
        type === 'ddOnHoldReasons' &&
        !filterData.ddOnHoldReasons.length &&
        filterData.dueDiligenceStages.indexOf('Hold') > -1
      )
        filterData.dueDiligenceStages.splice(
          filterData.dueDiligenceStages.indexOf('Hold'),
          1
        )
      else if (
        type === 'bpOnHoldReasons' &&
        !filterData.bpOnHoldReasons.length &&
        filterData.businessPlanStages.indexOf('Hold') > -1
      )
        filterData.businessPlanStages.splice(
          filterData.businessPlanStages.indexOf('Hold'),
          1
        )
      else if (type === 'dueDiligenceStages' && value === 'Hold')
        filterData['ddOnHoldReasons'] = []
      else if (type === 'businessPlanStages' && value === 'Hold')
        filterData['bpOnHoldReasons'] = []
      if (!filterData.profilingStages || !filterData.profilingStages.length)
        filterData['profilingStage'] = false
      if (
        !filterData.dueDiligenceStages ||
        !filterData.dueDiligenceStages.length
      )
        filterData['dueDiligenceStage'] = false
      if (
        !filterData.businessPlanStages ||
        !filterData.businessPlanStages.length
      )
        filterData['businessPlanStage'] = false
      if (
        !filterData.capitalFulfilledStages ||
        !filterData.capitalFulfilledStages.length
      )
        filterData['capitalFulfilledStage'] = false
      if (
        !filterData.enterpriseSetupStages ||
        !filterData.enterpriseSetupStages.length
      )
        filterData['enterpriseSetupStage'] = false
      if (
        !filterData.enterpriseSustainabilityStages ||
        !filterData.enterpriseSustainabilityStages.length
      )
        filterData['enterpriseSustainabilityStage'] = false
    } else {
      filterData[type].push(value)
      if (
        type === 'ddOnHoldReasons' &&
        filterData.dueDiligenceStages.indexOf('Hold') === -1
      )
        filterData.dueDiligenceStages.push('Hold')
      else if (
        type === 'bpOnHoldReasons' &&
        filterData.businessPlanStages.indexOf('Hold') === -1
      )
        filterData.businessPlanStages.push('Hold')
      else if (type === 'dueDiligenceStages') {
        if (filterData.dueDiligenceStages.indexOf('Hold') === -1)
          filterData['ddOnHoldReasons'] = []
        else if (value === 'Hold')
          filterData['ddOnHoldReasons'] = JSON.parse(
            JSON.stringify(this.state.ddOnHoldReasons)
          )
      } else if (type === 'businessPlanStages') {
        if (filterData.businessPlanStages.indexOf('Hold') === -1)
          filterData['bpOnHoldReasons'] = []
        else if (value === 'Hold')
          filterData['bpOnHoldReasons'] = JSON.parse(
            JSON.stringify(this.state.bpOnHoldReasons)
          )
      } else if (
        type === 'disqualificationReasons' &&
        !filterData.disqualificationReasons.length
      )
        filterData['disqualified'] = false
    }

    sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
    this.createBusinessIdeasQuery(filterData)
    this.setState({ filterData }, () => {
      this.submitFilter('searchText')
    })
  }

  selectOnHoldReasons = (type, value) => {
    let filterData = this.state.filterData
    if (type === 'dueDiligenceStage') {
      if (value) {
        if (filterData.dueDiligenceStages.indexOf('Hold') === -1)
          filterData.dueDiligenceStages.push('Hold')
        filterData.ddOnHoldReasons = this.state.ddOnHoldReasons
      } else {
        if (filterData.dueDiligenceStages.indexOf('Hold') > -1)
          filterData.dueDiligenceStages.splice(
            filterData.dueDiligenceStages.indexOf('Hold'),
            1
          )
        filterData.ddOnHoldReasons = []
      }
    } else if (type === 'businessPlanStage') {
      if (value) {
        if (filterData.businessPlanStages.indexOf('Hold') === -1)
          filterData.businessPlanStages.push('Hold')
        filterData.bpOnHoldReasons = this.state.bpOnHoldReasons
      } else {
        if (filterData.businessPlanStages.indexOf('Hold') > -1)
          filterData.businessPlanStages.splice(
            filterData.businessPlanStages.indexOf('Hold'),
            1
          )
        filterData.bpOnHoldReasons = []
      }
    }

    sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
    this.createBusinessIdeasQuery(filterData)
    this.setState({ filterData }, () => {
      this.submitFilter('searchText')
    })
  }

  createBusinessIdeasQuery = filterData => {
    let businessIdeasQuery = '?'
    // if (filterData.loanSchemeId)
    //   businessIdeasQuery += `loanSchemeId=${filterData.loanSchemeId}&`;

    if (filterData.pwd) businessIdeasQuery += 'pwd=' + filterData.pwd
    if (
      filterData.loanSchemeId &&
      filterData.loanSchemeId.length &&
      filterData.loanSchemeId[0]
    )
      businessIdeasQuery += '&loanSchemeId=' + filterData.loanSchemeId.join(',')
    if (filterData.state) businessIdeasQuery += '&state=' + filterData.state
    if (filterData.district.length && filterData.district[0])
      businessIdeasQuery += '&district=' + filterData.district.join(',')
    if (filterData.phase) businessIdeasQuery += `&phase=${filterData.phase}`
    if (filterData.audit) businessIdeasQuery += `&audit=${filterData.audit}`
    if (filterData.entrepreneurStoryVerification)
      businessIdeasQuery += `&entrepreneurStoryVerification=${filterData.entrepreneurStoryVerification}`
    if (filterData.gender) businessIdeasQuery += `&gender=${filterData.gender}`
    if (filterData.category)
      businessIdeasQuery += `&category=${filterData.category}`
    if (filterData.collateral)
      businessIdeasQuery += '&collateral=' + filterData.collateral
    if (filterData.toDate)
      businessIdeasQuery += `&toDate=${moment(filterData.toDate).format(
        'DD-MM-YYYY'
      )}`
    if (filterData.fromDate)
      businessIdeasQuery += `&fromDate=${moment(filterData.fromDate).format(
        'DD-MM-YYYY'
      )}`
    if (filterData.financeType !== '')
      businessIdeasQuery += `&financeType=${encodeURIComponent(
        filterData.financeType
      )}`
    if (filterData.overallSentiment !== '')
      businessIdeasQuery += `&overallSentiment=${filterData.overallSentiment}`
    if (filterData.strengthRating !== '')
      businessIdeasQuery += `&strengthRating=${filterData.strengthRating}`
    if (filterData.filedIncomeTax !== '')
      businessIdeasQuery += `&filedIncomeTax=${filterData.filedIncomeTax}`
    if (filterData.modeOfApplication !== '')
      businessIdeasQuery += `&modeOfApplication=${filterData.modeOfApplication}`
    if (filterData.disqualified !== '')
      businessIdeasQuery += `&disqualified=${filterData.disqualified}`
    if (filterData.starred !== '')
      businessIdeasQuery += `&starred=${filterData.starred}`
    if (filterData.onHold !== '')
      businessIdeasQuery += `&onHold=${filterData.onHold}`
    if (filterData.profilingStage && filterData.profilingStages.length)
      businessIdeasQuery += `&profilingStages=${filterData.profilingStages}`
    if (filterData.dueDiligenceStage && filterData.dueDiligenceStages.length)
      businessIdeasQuery += `&dueDiligenceStages=${filterData.dueDiligenceStages}`
    if (filterData.businessPlanStage && filterData.businessPlanStages.length)
      businessIdeasQuery += `&businessPlanStages=${filterData.businessPlanStages}`
    if (
      filterData.capitalFulfilledStage &&
      filterData.capitalFulfilledStages.length
    )
      businessIdeasQuery += `&capitalFulfilledStages=${filterData.capitalFulfilledStages}`
    if (
      filterData.enterpriseSetupStage &&
      filterData.enterpriseSetupStages.length
    )
      businessIdeasQuery += `&enterpriseSetupStages=${filterData.enterpriseSetupStages}`
    if (
      filterData.dueDiligenceStages &&
      filterData.dueDiligenceStages.indexOf('Hold') > -1 &&
      filterData.ddOnHoldReasons &&
      filterData.ddOnHoldReasons.length
    )
      businessIdeasQuery += `&ddOnHoldReasons=${filterData.ddOnHoldReasons.join(
        '|'
      )}`
    if (
      filterData.businessPlanStages &&
      filterData.businessPlanStages.indexOf('Hold') > -1 &&
      filterData.bpOnHoldReasons &&
      filterData.bpOnHoldReasons.length
    )
      businessIdeasQuery += `&bpOnHoldReasons=${filterData.bpOnHoldReasons.join(
        '|'
      )}`
    if (
      filterData.enterpriseSustainabilityStage &&
      filterData.enterpriseSustainabilityStages.length
    )
      businessIdeasQuery += `&enterpriseSustainabilityStages=${filterData.enterpriseSustainabilityStages}`
    if (
      filterData.disqualified &&
      filterData.disqualificationReasons &&
      filterData.disqualificationReasons.length
    )
      businessIdeasQuery += `&disqualificationReasons=${filterData.disqualificationReasons.join(
        '|'
      )}`
    if (filterData.tentativeHorizonToCloseThis)
      businessIdeasQuery += `&tentativeHorizonToCloseThis=${filterData.tentativeHorizonToCloseThis}`
    if (filterData.maturityStatus.length && filterData.maturityStatus[0])
      businessIdeasQuery += `&maturityStatus=${filterData.maturityStatus.join(
        ','
      )}`
    if (
      filterData.capitalFulfilledStatus &&
      filterData.capitalFulfilledStatus.length &&
      filterData.capitalFulfilledStatus[0]
    )
      businessIdeasQuery += `&capitalFulfilledStatus=${filterData.capitalFulfilledStatus.join(
        ','
      )}`
    if (filterData.source !== '')
      businessIdeasQuery += `&source=${filterData.source}`

    if (businessIdeasQuery === '?') businessIdeasQuery = ''

    this.getAllBusinessIdeas(businessIdeasQuery, filterData.idea)
  }

  addressFormatter = (cell, row) => {
    if (cell) return cell
    else return null
  }

  // Custom formatter to get state from both basic and advance stages
  stateFormatter = (cell, row) => {
    // Check basic stage first
    const basicState = row.userInfo?.address?.state;
    if (basicState) return basicState;

    // Check advance stage
    const advanceState = row.surveyData?.stages?.[0]?.form_data?.state;
    if (advanceState) return advanceState;

    return '-';
  }

  // Custom formatter to get district from both basic and advance stages
  districtFormatter = (cell, row) => {
    // Check basic stage first
    const basicDistrict = row.userInfo?.address?.district;
    if (basicDistrict) return basicDistrict;

    // Check advance stage
    const advanceDistrict = row.surveyData?.stages?.[0]?.form_data?.district;
    if (advanceDistrict) return advanceDistrict;

    return '-';
  }

  // Custom formatter to get village from both basic and advance stages
  villageFormatter = (cell, row) => {
    // Check basic stage first
    const basicVillage = row.userInfo?.address?.village;
    if (basicVillage) return basicVillage;

    // Check advance stage
    const advanceVillage = row.surveyData?.stages?.[0]?.form_data?.village;
    if (advanceVillage) return advanceVillage;

    return '-';
  }

  // Custom formatter to get block from both basic and advance stages
  blockFormatter = (cell, row) => {
    // Check basic stage first
    const basicBlock = row.userInfo?.address?.block;
    if (basicBlock) return basicBlock;

    // Check advance stage
    const advanceBlock = row.surveyData?.stages?.[0]?.form_data?.block;
    if (advanceBlock) return advanceBlock;

    return '-';
  }

  // Custom formatter to get Aadhaar number from both basic and advance stages
  aadharFormatter = (cell, row) => {
    // Check basic stage first (top-level field)
    const basicAadhar = row.aadhar_number;
    if (basicAadhar) return basicAadhar.toString();

    // Check advance stage
    const advanceAadhar = row.surveyData?.stages?.[0]?.form_data?.aadharNumber;
    if (advanceAadhar) return advanceAadhar.toString();

    return '-';
  }

  nameFormatter = (cell, row) => {
    if (!cell) return null // Return null if cell is empty

    if (row.userInfo?._id) {
      console.log("Row data:", row);
      console.log("fieldViewData:", row.fieldViewData);

      const fieldViewId = row.fieldViewData?.[0]?._id || '';
      console.log("Extracted fieldViewId:", fieldViewId);

      const baseUrl = `/user-profile/${row.userInfo._id || row.id}`;
      const queryParams = [];

      if (row.clusterName) {
        queryParams.push(`clusterName=${encodeURIComponent(row.clusterName)}`);
      }
      if (fieldViewId) {
        queryParams.push(`fieldViewId=${fieldViewId}`);
      }

      const fullUrl = queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl;
      console.log("Final URL:", fullUrl);

      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <a
            href={fullUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={row.enterpriseSetup ? { color: '#fff' } : null}
          >
            {cell}
          </a>
          <button
            onClick={(e) => {
              e.preventDefault();
              this.setState({
                quickViewDrawerVisible: true,
                quickViewLeadId: row.userInfo?._id || row.id
              });
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#ff8701',
              cursor: 'pointer',
              padding: '2px 6px',
              fontSize: '14px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Quick View Profile"
          >
            <i className="fa fa-eye" />
          </button>
        </div>
      )
    }

    return cell
  }

  selectFormatter = (cell, row, index) => {
    const addToSelcted = e => {
      let addSelected = this.state.selectedLeads
      let addSelectedIds = this.state.selectedLeadsIds
      // if (addSelected.some(item => item.id === row._id)) {
      //     const removeIndex = addSelected.map(item => item.id).indexOf(row._id);
      //     removeIndex >= 0 && addSelected.splice(removeIndex, 1);
      // }
      if (!e.target.checked) {
        const removeIndex = addSelected.map(item => item.id).indexOf(row._id)
        removeIndex >= 0 && addSelected.splice(removeIndex, 1)
        addSelectedIds = addSelected.map(x => x._id)
      } else {
        const newItem = {
          name: row.name,
          mobileNumber: row.mobileNumber,
          id: row._id,
          _id: row._id,
        }
        addSelected.push(newItem)
        addSelectedIds = addSelected.map(x => x._id)
      }

      this.setState({
        selectedLeads: addSelected,
        selectedLeadsIds: addSelectedIds,
      })
    }
    return (
      <Checkbox
        id={row._id}
        // defaultChecked={this.state.allLeadsSelected}
        checked={
          this.state.allLeadsSelected ||
          this.state.selectedLeadsIds.includes(row._id)
        }
        // defaultChecked={this.state.allLeadsSelected || this.state.selectedLeadsIds.includes(row._id)}
        onChange={e => addToSelcted(e)}
      />
    )
  }

  starFormatter = (cell, row, index) => {
    if (cell) {
      if (row.enterpriseSetup)
        return (
          <i
            className="fa fa-star"
            style={{ fontSize: 20, color: '#fff' }}
            onClick={this.toggleStar.bind(this, row.id, !cell, index)}
          ></i>
        )
      else
        return (
          <i
            className="fa fa-star"
            style={{ fontSize: 20, color: 'var(--themeColor)' }}
            onClick={this.toggleStar.bind(this, row.id, !cell, index)}
          ></i>
        )
    } else {
      return (
        <i
          className="fa fa-star-o"
          style={{ fontSize: 20 }}
          onClick={this.toggleStar.bind(this, row.id, !cell, index)}
        ></i>
      )
    }
  }

  addedByFormatter = (cell, row) => {
    if (!cell.id && row.generatedThrough === 'Learning App') {
      return 'Self'
    } else {
      return cell.fullName
    }
  }

  assignToFormatter = (cell, row) => {
    if (cell && cell.hasOwnProperty('_id')) {
      if (cell && cell.fullName) {
        if (
          row.userType &&
          (JSON.parse(readCookie('userData')).type === 'le' ||
            JSON.parse(readCookie('userData')).type === 'sidbi')
        ) {
          return (
            <a
              href={'/user-types/' + row.userType + '/' + cell._id}
              style={row.enterpriseSetup ? { color: '#fff' } : null}
            >
              {cell.fullName}
            </a>
          )
        } else return cell.fullName
      } else if (cell && cell.ngoName) {
        return (
          <a
            href={
              JSON.parse(readCookie('userData')).type === 'partners'
                ? '/settings'
                : '/org-types/swavalamban-connect-kendra/' + cell._id
            }
            style={row.enterpriseSetup ? { color: '#fff' } : null}
          >
            {cell.ngoName}
          </a>
        )
      } else if (cell && cell.udaanName) {
        return (
          <a
            href={
              JSON.parse(readCookie('userData')).type === 'partners'
                ? '/settings'
                : '/udaan-centres/udaan/' + cell._id
            }
            style={row.enterpriseSetup ? { color: '#fff' } : null}
          >
            {cell.udaanName}
          </a>
        )
      } else return null
    } else return null
  }

  yesnoFormatter = (cell, row) => {
    if (cell) return 'Yes'
    else if (cell === false) return 'No'
    else return null
  }
  localeStringFormatter = cell => {
    if (cell && cell !== 'N/A')
      return <span>{parseFloat(cell).toLocaleString()}</span>
    else if (cell === 'N/A') return <span>{cell}</span>
    else return null
  }
  formatCreatedAt = (cell, row) => {
    if (cell) {
      return moment(cell).format('DD/MM/YYYY hh:mm A')
    } else return <span>-</span>
  }
  formatBplanAge = (cell, row) => {
    if (cell) {
      return <span>{isNaN(cell) ? '-' : Math.floor(cell)}</span>
    }
  }

  formatSaarthis = (cell, row) => {
    if (cell) {
      return (
        <span>
          <a
            className="saarthi-name"
            href={'/user-types/saarthis/' + cell._id}
            target="_blank"
            rel="noopener noreferrer"
          >
            {cell.fullName}
          </a>
        </span>
      )
    } else return 'N/A'
  }

  formatEdit = (cell, row) => {
    if (row.id && JSON.parse(readCookie('userData')).type !== 'sidbi') {
      return (
        <button
          className="btn edit-lead-btn"
          onClick={() => (window.location.pathname = '/edit-lead/' + row.id)}
        >
          Edit
        </button>
      )
    } else return null
  }

  formatRating = (cell, row) => {
    if (cell) {
      return (
        <span className="note" style={{ fontSize: 18 }}>
          {cell}
        </span>
      )
    } else return null
  }

  toggleStar = (leadId, starred, index) => {
    let title = 'Are you sure you want to prioritize this lead?'
    if (!starred) title = 'Are you sure you want to deprioritize this lead?'
    Swal.fire({
      title,
      focusConfirm: false,
      showCancelButton: true,
      cancelButtonText: 'No, Cancel',
      confirmButtonText: 'Yes, Update',
      cancelButtonAriaLabel: 'No, Cancel',
      confirmButtonAriaLabel: 'Yes, Update',
    }).then(result => {
      if (result.value && leadId) {
        fetch(process.env.REACT_APP_API_URL + '/api/v1/swati-leads/' + leadId, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          body: JSON.stringify({ leadInfo: { starred } }),
        })
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              let allLeads = this.state.allLeads
              allLeads[index]['starred'] = starred
              this.setState({ allLeads })
            } else {
              this.notifyError('Could not update')
            }
          })
      }
    })
  }

  addNewLead = () => {
    window.location.pathname = '/leads/new'
  }

  importLeadsFromCSV = () => {
    this.setState({ showImportModal: true, importStage: '' })
  }

  searchFilter = (input, option) => {
    input = input.toLowerCase()
    if (!Array.isArray(option.props.children)) {
      if (typeof option.props.children === 'string') {
        return (
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      }
    }
  }

  showFilter = () => {
    this.setState({ showFilter: !this.state.showFilter })
  }

  onTableChange = (type, obj) => {
    if (type === 'sort' && obj.sortOrder && obj.sortField) {
      this.submitFilter(
        type,
        obj.page,
        obj.sizePerPage,
        obj.searchText,
        obj.sortField,
        obj.sortOrder
      )
    } else {
      let changeType = ''
      if (this.state.page !== obj.page) changeType = 'page'
      else if (this.state.sizePerPage !== obj.sizePerPage)
        changeType = 'sizePerPage'
      else if (this.state.searchText !== obj.searchText)
        changeType = 'searchText'

      this.setState({
        page: obj.page,
        sizePerPage: obj.sizePerPage,
        searchText: obj.searchText,
      })
      this.submitFilter(changeType, obj.page, obj.sizePerPage, obj.searchText)
    }
  }

  // handleTabChange = (tabKey) => {
  //   this.state.activeTab==='basic'?this.setState({activeTab:'baseline'}):this.setState({activeTab:'basic'}
  //     //update bootstrap table data on tab change

  //   )
  // }

  // 6. FIX: Update handleTabChange
  handleTabChange = (tabKey) => {
    let filteredData = this.state.allData || [];

    if (tabKey === 'basic') {
      filteredData = filteredData.filter(item => item.stage === 'basic');
    } else if (tabKey === 'advance') {
      filteredData = filteredData.filter(item => item.stage === 'advance');
    }
    // If 'combined', show all data

    this.setState({
      activeTab: tabKey,
      allUsers: filteredData,
      filteredUsers: filteredData,
      page: 1,
      filterData: {
        ...this.state.filterData,
        stage: tabKey === 'combined' ? '' : tabKey
      }
    });
  };


  rowClassNameFormat = (row, index) => {
    // coloring setup enterprises
    if (row.enterpriseSetup) {
      return { backgroundColor: '#78D245' }
    } else if (row.saarthis && row.saarthis.status === 'Active') {
      if (row.saarthis.saarthiAccess === 'dueDiligence')
        return { backgroundColor: '#FFE8FE' }
      else return { backgroundColor: '#D4FFFF' }
    }
    // coloring for follow-ups
    if (this.state.followUpDues) {
      if (
        this.state.followUpDues.dueToday &&
        this.state.followUpDues.dueToday.indexOf(row.id) > -1
      )
        return { backgroundColor: 'rgb(250, 236, 47,0.8)' }
      if (
        this.state.followUpDues.overDue &&
        this.state.followUpDues.overDue.indexOf(row.id) > -1
      )
        return { backgroundColor: 'rgb(166, 0, 0, 0.2)' }
      if (
        this.state.followUpDues.dueThisWeek &&
        this.state.followUpDues.dueThisWeek.indexOf(row.id) > -1
      )
        return { backgroundColor: 'rgba(73, 154, 255, 0.75)' }
    }
  }

  starredStyle = (cell, row) => {
    if (cell) return { backgroundColor: '#FFF2C9' }
  }
  removeFilter = (type, value) => {
    this.setState({ filteredUsers: this.state.allUsers })

    let filterData = this.state.filterData
    if (type === 'state' || type === 'cluster') {
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/location/districts?sortBy=name',
        {
          method: 'GET',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            this.setState({ allDistricts: data.districts })
          }
        })
    }

    if (type === 'cluster') {
      filterData['state'] = ''
      filterData['district'] = []
    } else if (type === 'userType') {
      filterData['assignedTo'] = ''
    } else if (type === 'loanSchemes') {
      filterData['loanSchemeId'] = []
      filterData['loanScheme'] = []
    }
    filterData[type] = value
    sessionStorage.setItem('getAllLeadsFilter', JSON.stringify(filterData))
    this.createBusinessIdeasQuery(filterData)
    this.setState({ filterData }, () => {
      if (this.state.allData && this.state.allData.length > 0) {
        this.applyFilters();
      } else {
        this.submitFilter('searchText');
      }
    })
  }
  handleSelectChange = row => {
    let selectedLeadsIds = this.state.selectedLeadsIds
    if (!selectedLeadsIds.includes(row._id)) {
      selectedLeadsIds.push(row._id)
    } else {
      const removeIndex = selectedLeadsIds
        .map(item => item._id)
        .indexOf(row._id)
      removeIndex >= 0 && selectedLeadsIds.splice(removeIndex, 1)
    }
    this.setState({ selectedLeadsIds })
  }
  handleSelectAllChange = selected => {
    if (selected) {
      this.setState({ selectedLeadsIds: this.state.selectAllLeadsInfo || [] })
    } else {
      this.setState({ selectedLeadsIds: [] })
    }
  }
  render() {
    const SELECTED_ESS = this.state.filterData.essOptedFor
    const selectedESSArr = SELECTED_ESS
      ? this.state.allSupportServices.filter(item => item._id === SELECTED_ESS)
      : []
    const selectedEssString =
      selectedESSArr && selectedESSArr.length
        ? selectedESSArr[0].serviceDetails.serviceTitle
        : ''
    const selectRow = {
      mode: 'checkbox',
      clickToSelect:
        JSON.parse(readCookie('userData')).userType.name ===
        'Project Management Unit' && this.state.selectMode,
      selected: this.state.selectedLeadsIds,
      onSelect: this.handleSelectChange,
      onSelectAll: this.handleSelectAllChange,
      hideSelectColumn: !(
        JSON.parse(readCookie('userData')).userType.name ===
        'Project Management Unit' && this.state.selectMode
      ),
    }
    const allSentiments = [
      'Very enthusiastic',
      'Enthusiastic',
      'Exploring enterprise options in addition to the current engagement',
      'Not very enthusiastic',
    ],
      allHorizons = [
        'Under 1 month',
        '1-3 months',
        '3-6 months',
        '6-12 months',
        '12-24 months',
        '>24 months',
      ],
      //allBanks = allBanks,
      // [
      //   "//Allahabad Bank",
      //   "Andhra Bank",
      //   "Andhra Pradesh Grameena Vikas Bank",
      //   "Aryavart Bank",
      //   "Axis Bank",
      //   "Bandhan Bank",
      //   "Bank of Bahrain and Kuwait",
      //   "Bank of Baroda",
      //   "Bank of India",
      //   "Bank of Maharashtra",
      //   "Baroda Uttar Pradesh Gramin Bank",
      //   "Canara Bank",
      //   "Central Bank of India",
      //   "City Union Bank",
      //   "Corporation Bank",
      //   "Dakshin Bihar Gramin Bank",
      //   "Dena Bank",
      //   "Deutsche Bank",
      //   "Development Credit Bank",
      //   "Dhanlaxmi Bank",
      //   "Federal Bank",
      //   "Fino Payments Bank",
      //   "Gramin Bank",
      //   "HDFC Bank",
      //   "ICICI Bank",
      //   "IDBI Bank",
      //   "Indian Bank",
      //   "Indian Post Payments Bank",
      //   "Indian Overseas Bank",
      //   "IndusInd Bank",
      //   "ING Vysya Bank",
      //   "Jammu and Kashmir Bank",
      //   "Karnataka Bank Ltd",
      //   "Karur Vysya Bank",
      //   "Kashi Gomti Samyut Gramin Bank",
      //   "Kotak Bank",
      //   "Laxmi Vilas Bank",
      //   "Oriental Bank of Commerce",
      //   "Prathama Bank",
      //   "Punjab National Bank - Corporate Banking",
      //   "Punjab National Bank - Retail Banking",
      //   "Punjab &amp; Sind Bank",
      //   "RBL Bank",
      //   "Shamrao Vitthal Co-operative Bank",
      //   "South Indian Bank",
      //   "State Bank of Bikaner &amp; Jaipur",
      //   "State Bank of Hyderabad",
      //   "State Bank of India",
      //   "State Bank of Mysore",
      //   "State Bank of Patiala",
      //   "State Bank of Travancore",
      //   "Syndicate Bank",
      //   "Tamilnad Mercantile Bank Ltd.",
      //   "UCO Bank",
      //   "Union Bank of India",
      //   "United Bank of India",
      //   "Uttar Bihar Gramin Bank",
      //   "Vijaya Bank",
      //   "Yes Bank Ltd",
      // ],
      columns =
        window.screen.width < 500
          ? [
            {
              text: 'S.No.',
              sort: true,
              hidden: false,
              searchable: true,
              headerStyle: () => {
                return { width: '50px' }
              },
              dataField: 'id',
              export: false,
            },
            {
              text: 'Name',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '200px' }
              },
              dataField: 'userInfo.name',
              formatter: this.nameFormatter,
            },
            {
              text: 'Surveyed By',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              dataField: 'surveyorName',
              headerStyle: () => {
                return { width: '150px' }
              },
              formatter: (cell) => cell || '-',
              csvFormatter: (cell) => cell || '-'
            },
            {
              text: 'Stage',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '100px' }
              },
              dataField: 'stage',
              formatter: (cell, row) => (cell === 'advance' ? 'Advanced' : 'Basic'),
            },
            {
              text: 'Mobile No.',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '110px' }
              },
              dataField: 'userInfo.mobileNumber',
            },
            {
              text: 'District',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '130px' }
              },
              dataField: 'userInfo.address.district',
              formatter: this.districtFormatter,
            },
            {
              text: 'Village',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'userInfo.address.village',
              formatter: this.villageFormatter,
            },
            {
              text: 'Block',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'userInfo.address.block',
              formatter: this.blockFormatter,
            },
            {
              text: 'Aadhaar Number',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'aadhar_number',
              formatter: this.aadharFormatter,
            },
            {
              text: 'SRLM Associated',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '120px' }
              },
              dataField: 'srlm_associated',
              formatter: (cell) => {
                if (cell === true) return 'Yes';
                if (cell === false) return 'No';
                return '-';
              },
            },
            {
              text: 'Apiary',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '130px' }
              },
              dataField: 'apiaryStatus',
              formatter: (cell) => {
                if (cell === 'Active') {
                  return <span className="badge badge-success" style={{ backgroundColor: '#e6fffa', color: '#00b894', border: '1px solid #b2f2bb', padding: '5px 10px', borderRadius: '12px', fontWeight: '600' }}>🟢 Active</span>;
                }
                if (cell === 'Inactive') {
                  return <span className="badge badge-danger" style={{ backgroundColor: '#fff5f5', color: '#d63031', border: '1px solid #ffa8a8', padding: '5px 10px', borderRadius: '12px', fontWeight: '600' }}>🔴 Inactive</span>;
                }
                return <span className="badge badge-secondary" style={{ backgroundColor: '#f1f2f6', color: '#636e72', border: '1px solid #dfe6e9', padding: '5px 10px', borderRadius: '12px', fontWeight: '500' }}>⚪ Absent</span>;
              },
              csvFormatter: (cell) => cell || 'Absent',
            }

          ]
          : [
            {
              text: 'S.No.',
              sort: true,
              hidden: false,
              searchable: true,
              headerStyle: () => {
                return { width: '40px' }
              },
              dataField: 'id',
              //count the  number of rows
              export: true,
              formatter: (cell, row, index) => {
                return (
                  this.state.page * this.state.sizePerPage +
                  index +
                  1 -
                  this.state.sizePerPage
                )
              },
              csvFormatter: (cell, row, rowIndex) => {
                return (
                  this.state.page * this.state.sizePerPage +
                  rowIndex +
                  1 -
                  this.state.sizePerPage
                )
              },
            },
            {
              text: 'Name',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'userInfo.name',
              formatter: this.nameFormatter,
            },
            {
              text: 'Surveyed By',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              dataField: 'surveyorName',
              headerStyle: () => {
                return { width: '150px' }
              },
              formatter: (cell) => cell || '-',
              csvFormatter: (cell) => cell || '-'
            },
            {
              text: 'Stage',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '100px' }
              },
              dataField: 'stage',
              formatter: (cell, row) => (cell === 'advance' ? 'Advanced' : 'Basic'),
            },
            {
              text: 'Gender',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '80px' }
              },
              dataField: 'userInfo.gender',
              formatter: (cell) => {
                if (!cell) return '-';
                return cell.charAt(0).toUpperCase() + cell.slice(1).toLowerCase();
              },
            },
            {
              text: 'Age',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '50px' }
              },
              dataField: 'userInfo',
              formatter: (cell, row) => {
                if (
                  !process.env.REACT_APP_HUMBLEBEE_API_URL?.includes(
                    'devapi.thehumblebee.co'
                  )
                ) {
                  let age = row?.surveyData?.stages?.[0]?.form_data?.dob ?? ''
                  if (age) {
                    let dob = new Date(age)
                    let diff_ms = Date.now() - dob.getTime()
                    let age_dt = new Date(diff_ms)
                    let formatted_dob =
                      dob.getDate() +
                      '-' +
                      (dob.getMonth() + 1) +
                      '-' +
                      dob.getFullYear()
                    return Math.abs(age_dt.getUTCFullYear() - 1970)
                  }
                }
                return '-'
              },
            },
            {
              text: 'Mobile No.',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '110px' }
              },
              dataField: 'userInfo.mobileNumber',
            },
            {
              text: 'State',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '110px' }
              },
              dataField: 'userInfo.address.state',
              formatter: this.stateFormatter,
            },
            {
              text: 'District',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'userInfo.address.district',
              formatter: this.districtFormatter,
            },
            {
              text: 'Village',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'userInfo.address.village',
              formatter: this.villageFormatter,
            },
            {
              text: 'Block',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'userInfo.address.block',
              formatter: this.blockFormatter,
            },
            {
              text: 'Aadhaar Number',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '150px' }
              },
              dataField: 'aadhar_number',
              formatter: this.aadharFormatter,
            },
            {
              text: 'SRLM Associated',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '120px' }
              },
              dataField: 'srlm_associated',
              formatter: (cell) => {
                if (cell === true) return 'Yes';
                if (cell === false) return 'No';
                return '-';
              },
            },
            {
              text: 'Apiary',
              sort: true,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '130px' }
              },
              dataField: 'apiaryStatus',
              formatter: (cell) => {
                if (cell === 'Active') {
                  return <span className="badge badge-success" style={{ backgroundColor: '#e6fffa', color: '#00b894', border: '1px solid #b2f2bb', padding: '5px 10px', borderRadius: '12px', fontWeight: '600' }}>🟢 Active</span>;
                }
                if (cell === 'Inactive') {
                  return <span className="badge badge-danger" style={{ backgroundColor: '#fff5f5', color: '#d63031', border: '1px solid #ffa8a8', padding: '5px 10px', borderRadius: '12px', fontWeight: '600' }}>🔴 Inactive</span>;
                }
                return <span className="badge badge-secondary" style={{ backgroundColor: '#f1f2f6', color: '#636e72', border: '1px solid #dfe6e9', padding: '5px 10px', borderRadius: '12px', fontWeight: '500' }}>⚪ Absent</span>;
              },
              csvFormatter: (cell) => cell || 'Absent',
            },
            {
              text: 'Project Name',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '250px' }
              },
              dataField: 'projectName',
              csvFormatter: (cell, row) => {
                return cell ? cell : 'No Cluster Assigned'
              },
              formatter: (cell, row) => {
                // console.log(cell);
                if (cell) {
                  return <p style={{ color: 'green' }}>{cell}</p>
                } else {
                  return <p style={{ color: 'red' }}>-</p>
                }
              },
            },
            {
              text: 'Cluster Name',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '200px' }
              },
              dataField: 'clusterName',
              csvFormatter: (cell, row) => {
                return cell ? cell : 'No Cluster Assigned'
              },
              formatter: (cell, row) => {
                // console.log(cell);
                if (cell) {
                  return <p style={{ color: 'green' }}>{cell}</p>
                } else {
                  return <p style={{ color: 'red' }}>-</p>
                }
              },
            },
            {
              text: 'Cluster Assigned',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '70px' }
              },
              dataField: 'fieldViewData[0].cluster_id',
              formatter: (cell, row) => {
                if (cell) {
                  return <p style={{ color: 'green' }}>Yes</p>
                } else {
                  return <p style={{ color: 'red' }}>No</p>
                }
              },
              csvFormatter: (cell, row) => {
                // For modifying data in the CSV export
                return cell ? 'Yes' : 'No'
              },
            },
            {
              text: 'App Installed',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              headerStyle: () => {
                return { width: '80px' }
              },
              dataField: 'userInfo.logged_in',
              formatter: (cell, row) => {
                if (cell) {
                  return <span style={{ color: 'green' }}>Yes</span>
                } else {
                  return <span style={{ color: 'red' }}>No</span>
                }
              },
              csvFormatter: (cell, row) => {
                return cell ? 'Yes' : 'No'
              }
            },
            {
              text: 'User Added On',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              dataField: 'userInfo.addedAt',
              headerStyle: () => {
                return { width: '150px' }
              },
              formatter: this.formatCreatedAt,
            },
            {
              text: 'Added On',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              dataField: 'fieldViewData[0].created_at',
              headerStyle: () => {
                return { width: '150px' }
              },
              formatter: this.formatCreatedAt,
            },
            {
              text: 'Updated On',
              sort: false,
              hidden: false,
              export: true,
              searchable: true,
              dataField: 'fieldViewData[0].updated_at',
              headerStyle: () => {
                return { width: '150px' }
              },
              formatter: this.formatCreatedAt,
            },
            // {
            //   text: "SIDBI Payment Milestone",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "sidbiMilestone",
            // },
            // {
            //   text: "Due-diligence done at",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "ddCompletedAt",
            //   formatter: this.formatCreatedAt,
            // },
            // {
            //   text: "Bplan done At",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "bplanCompletedAt",
            //   formatter: this.formatCreatedAt,
            // },
            // {
            //   text: "Bplan Age (in days)",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "50px", textAlign: "center" };
            //   },
            //   dataField: "bplanAge",
            //   formatter: this.formatBplanAge,
            // },
            // {
            //   text: "Loan Application Done At",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "loanApplicationCompletedAt",
            //   formatter: this.formatCreatedAt,
            // },
            // {
            //   text: "Loan Application Status",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "loanApplicationStatus",
            // },
            // {
            //   text: "Started/Scaled Up on(in)",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "enterpriseSetUpAt",
            //   // formatter: this.formatCreatedAt,
            // },
            // {
            //   text: "Enterprise status last updated on",
            //   sort: true,
            //   hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "enterpriseUpdatedOn",
            //   formatter: this.formatCreatedAt,
            // },
            // {
            //   text: "Enterprise marked started/scaled up on",
            //   sort: true,
            //   hidden: JSON.parse(readCookie("userData")).userType
            //     .name === "SIDBI",
            //   // hidden: false,
            //   export: true,
            //   searchable: true,
            //   headerStyle: () => {
            //     return { width: "150px", textAlign: "center" };
            //   },
            //   dataField: "enterpriseMarkedSetupOn",
            //   formatter: this.formatCreatedAt,
            // },
          ]
    if (window.screen.width > 500) {
      if (JSON.parse(readCookie('userData')).type === 'le') {
        // columns.splice(7, 0, {
        //   text: "Profile Completed (%)",
        //   sort: true,
        //   hidden: false,
        //   export: true,
        //   searchable: true,
        //   headerStyle: () => {
        //     return { width: "90px" };
        //   },
        //   dataField: "profileCompletion",
        // });
        // columns.splice(8, 0, {
        //   text: "Strength Rating",
        //   sort: true,
        //   hidden: false,
        //   export: true,
        //   searchable: true,
        //   headerStyle: () => {
        //     return { width: "70px", textAlign: "center" };
        //   },
        //   align: "center",
        //   dataField: "strengthRating",
        //   formatter: this.formatRating,
        // });
        if (JSON.parse(readCookie('userData')).accountType !== 'saarthi') {
          // columns.splice(15, 0, {
          //   text: "SAARTHIs",
          //   sort: true,
          //   hidden: true,
          //   export: true,
          //   searchable: true,
          //   headerStyle: () => {
          //     return { width: "160px" };
          //   },
          //   dataField: "saarthis",
          //   formatter: this.formatSaarthis,
          // });
        }
        // columns.splice(9, 0, { text: 'Edit', sort: false, hidden: false, export: false, searchable: false, align: 'center', headerStyle: () => {return {width: '75px', textAlign: 'center'}}, dataField: 'edit', formatter: this.formatEdit });
      } else {
        // columns.splice(14, 0, {
        //   text: "Profile Completed (%)",
        //   sort: true,
        //   hidden: false,
        //   export: true,
        //   searchable: true,
        //   headerStyle: () => {
        //     return { width: "150px" };
        //   },
        //   dataField: "profileCompletion",
        // });
        // columns.splice(19, 0, {
        //   text: "Strength Rating",
        //   sort: true,
        //   hidden: false,
        //   export: true,
        //   searchable: true,
        //   headerStyle: () => {
        //     return { width: "140px", textAlign: "center" };
        //   },
        //   align: "center",
        //   dataField: "strengthRating",
        //   formatter: this.formatRating,
        // });
        // if(JSON.parse(readCookie('userData')).type !== 'sidbi') {
        // 	columns.splice(7, 0, { text: 'Edit', sort: false, hidden: false, export: false, searchable: false, align: 'center', headerStyle: () => {return {width: '75px', textAlign: 'center'}}, dataField: 'edit', formatter: this.formatEdit });
        // }
      }
    }
    let hasFilter = false
    if (
      this.state.filterData.bPlanCompleted === true ||
      this.state.filterData.source !== '' ||
      this.state.filterData.loanAppApplied === true ||
      this.state.filterData.eSetupInProgress === true ||
      this.state.filterData.fromDate ||
      this.state.filterData.toDate ||
      this.state.filterData.state ||
      (this.state.filterData.district &&
        this.state.filterData.district.length) ||
      (this.state.filterData.cluster && this.state.filterData.cluster.length) ||
      this.state.filterData.bplanAge ||
      this.state.filterData.minLoanAmount ||
      this.state.filterData.maxLoanAmount ||
      this.state.filterData.userType ||
      this.state.filterData.assignedTo ||
      this.state.filterData.taggedTo ||
      this.state.filterData.idea ||
      this.state.filterData.phase ||
      this.state.filterData.audit ||
      this.state.filterData.paymentClaim ||
      this.state.filterData.essOptedFor ||
      this.state.filterData.scaleUpQuestionnaire ||
      this.state.filterData.entrepreneurStoryVerification ||
      this.state.filterData.gender ||
      this.state.filterData.category ||
      this.state.filterData.financeType ||
      this.state.filterData.pwd ||
      this.state.filterData.hasComments ||
      this.state.filterData.businessPlanVerification ||
      this.state.filterData.collateral ||
      (this.state.filterData.bankAccounts &&
        this.state.filterData.bankAccounts.length) ||
      this.state.filterData.overallSentiment ||
      this.state.filterData.tentativeHorizonToCloseThis ||
      this.state.filterData.strengthRating ||
      this.state.filterData.filedIncomeTax ||
      this.state.filterData.modeOfApplication ||
      (this.state.filterData.loanSchemeId &&
        this.state.filterData.loanSchemeId.length) ||
      this.state.filterData.maturityStatus.length ||
      (this.state.filterData.capitalFulfilledStatus &&
        this.state.filterData.capitalFulfilledStatus.length) ||
      (!this.props.sidebarMinimized &&
        this.state.filterData.capitalFulfilledStage) ||
      this.state.filterData.sidbiMilestone
    )
      hasFilter = true

    return (
      <>
        <div
          className={
            this.props.type === 'swavalamban-connect-kendra' &&
              this.props.view === 'tab'
              ? 'leads-page'
              : this.props.sidebarMinimized &&
                window.location.pathname === '/leads'
                ? 'page-container leads-page sidebar-minimized'
                : 'page-container leads-page'
          }
        >
          {/* comment out for testing old code */}
          {false && (this.props.type !== 'swavalamban-connect-kendra' &&
            this.props.view !== 'tab' ? (
            <div className="page-heading d-flex">
              <h3>Surveys</h3>
              {JSON.parse(readCookie('userData')).type !== 'sidbi' &&
                JSON.parse(readCookie('userData')).accountType !== 'saarthi' ? (
                <div
                  className="filter add-new-prospect-container"
                  style={{ right: '40px', position: 'absolute' }}
                >
                  <Row>
                    {JSON.parse(readCookie('userData')).userType.name ===
                      'Project Management Unit' ? (
                      // || true
                      // <Col>
                      //   <button
                      //     // className="btn add-new-prospect-btn"
                      //     className="btn"
                      //     disabled
                      //     style={{ borderRadius: 0, width: "max-content" }}
                      //     onClick={this.importLeadsFromCSV}
                      //   >
                      //     <i className="fa fa-plus mr5" />
                      //     Import/Update Leads from a CSV/Excel file
                      //     <i className="fa fa-upload" aria-hidden="true" />
                      //   </button>
                      // </Col>
                      <></>
                    ) : null}
                    <Col>
                      {/* <button
                      className="btn add-new-prospect-btn"
                      style={{ borderRadius: 0 }}
                      onClick={this.addNewLead}
                    >
                      <i className="fa fa-plus mr5"></i>
                      Add New Prospect
                    </button> */}
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
          ) : null)}

          {false && (this.props.type !== 'swavalamban-connect-kendra' &&
            this.props.view !== 'tab' ? (
            <div className="page-heading d-flex">
              <h3>Surveys</h3>
              {JSON.parse(readCookie('userData')).type !== 'sidbi' &&
                JSON.parse(readCookie('userData')).accountType !== 'saarthi' ? (
                <div
                  className="filter add-new-prospect-container"
                  style={{ right: '40px', position: 'absolute' }}
                >
                  <Row>
                    {JSON.parse(readCookie('userData')).userType.name ===
                      'Project Management Unit' ? (
                      // || true
                      // <Col>
                      //   <button
                      //     // className="btn add-new-prospect-btn"
                      //     className="btn"
                      //     disabled
                      //     style={{ borderRadius: 0, width: "max-content" }}
                      //     onClick={this.importLeadsFromCSV}
                      //   >
                      //     <i className="fa fa-plus mr5" />
                      //     Import/Update Leads from a CSV/Excel file
                      //     <i className="fa fa-upload" aria-hidden="true" />
                      //   </button>
                      // </Col>
                      <></>
                    ) : null}
                    <Col>
                      {/* <button
                      className="btn add-new-prospect-btn"
                      style={{ borderRadius: 0 }}
                      onClick={this.addNewLead}
                    >
                      <i className="fa fa-plus mr5"></i>
                      Add New Prospect
                    </button> */}
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
          ) : null)}

          <div className="leads-container">
            <LoadingOverlay
              active={this.state.leadsLoading || false}
              spinner={<BounceLoader />}
            >
              <Col md={12} className="leads-table-container">
                {this.state.userData.userType.name !== 'Funder' &&
                  this.state.allUsers ? (
                  <PaginationProvider
                    pagination={paginationFactory({
                      custom: true,
                      totalSize: this.state.allUsers.length,
                      sizePerPage: this.state.sizePerPage,
                      sizePerPageList: [10, 25, 50, 100, 500, 1000, 2000, 3000, 5000],
                      page: this.state.page,
                      onPageChange: page => this.setState({ page }),
                      onSizePerPageChange: (sizePerPage, page) =>
                        this.setState({ sizePerPage, page }),
                    })}
                    keyField="_id"
                    data={
                      this.state.searchText.length > 0
                        ? this.state.filteredUsers.slice(
                          (this.state.page - 1) * this.state.sizePerPage,
                          this.state.page * this.state.sizePerPage
                        )
                        : this.state.allUsers.slice(
                          (this.state.page - 1) * this.state.sizePerPage,
                          this.state.page * this.state.sizePerPage
                        )
                    }
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={
                          this.state.searchText.length > 0
                            ? this.state.filteredUsers.slice(
                              (this.state.page - 1) * this.state.sizePerPage,
                              this.state.page * this.state.sizePerPage
                            )
                            : this.state.allUsers.slice(
                              (this.state.page - 1) * this.state.sizePerPage,
                              this.state.page * this.state.sizePerPage
                            )
                        }
                        columns={columns}
                        exportCSV={{
                          fileName:
                            new Date().getTime() + '_leads_data' + '.csv',
                          exportAll: false,
                        }}
                        search={{ searchFormatted: true }}
                      >
                        {props => (
                          <div>
                            {JSON.parse(readCookie('userData')).email ===
                              'monika@letsendorse.com' && (
                                <ExportCSVButton
                                  style={{ float: 'center' }}
                                  {...props.csvProps}
                                >
                                  Export Leads to CSV
                                </ExportCSVButton>
                              )}

                            {false &&
                              JSON.parse(readCookie('userData')).userType
                                .name === 'Project Management Unit' && (
                                <div
                                  align="end"
                                  className="row"
                                  style={{
                                    justifyContent: 'flex-end',
                                    paddingRight: 150,
                                  }}
                                >
                                  {this.state.selectMode && (
                                    <h5
                                      style={{
                                        color: '#ef5a20',
                                        fontWeight: 'bold',
                                        marginRight: 10,
                                        paddingTop: 5,
                                      }}
                                    >
                                      {this.state.selectedLeadsIds.length}{' '}
                                      Selected
                                    </h5>
                                  )}
                                  {this.state.selectMode > 0 && (
                                    <DropdownButton
                                      style={{ marginRight: 30 }}
                                      disabled={
                                        this.state.selectedLeadsIds.length === 0
                                      }
                                      id="dropdown-basic-button"
                                      title="&emsp;Take Action&emsp;"
                                      onChange={() =>
                                        console.log('SELECTED LEADS')
                                      }
                                    >
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.setState({
                                            showAddLeadsToProjectModal: true,
                                            projectMoveAction: 'add',
                                          })
                                        }}
                                      >
                                        Add to another project
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.setState({
                                            showAddLeadsToProjectModal: true,
                                            projectMoveAction: 'move',
                                          })
                                        }}
                                      >
                                        Move to another project
                                      </Dropdown.Item>
                                      {/* <Dropdown.Item onClick={() => {
                                      localStorage.setItem('selectedLeads', JSON.stringify(this.state.selectedLeads));
                                      window.open(process.env.REACT_APP_CAMPAIGN_URL+"?token=" + JSON.parse(readCookie("access_token")), "_blank")
                                    }
                                  }>
                                  Trigger Campaign
                                </Dropdown.Item> */}
                                    </DropdownButton>
                                  )}
                                  <h5 style={{ paddingTop: 2 }}>
                                    Selection Mode
                                  </h5>
                                  <Switch
                                    checked={this.state.selectMode}
                                    style={{
                                      transform: 'scale(1.3)',
                                      width: 80,
                                      marginLeft: 30,
                                    }}
                                    checkedChildren="On"
                                    unCheckedChildren="Off"
                                    onChange={e =>
                                      this.setState({
                                        allLeadsSelected: false,
                                        selectedLeads: [],
                                        selectedLeadsIds: [],
                                        selectMode: e,
                                      })
                                    }
                                  />
                                </div>
                              )}

                            {JSON.parse(readCookie('userData')).userType
                              .name === 'Project Management Unit' &&
                              this.state.selectMode &&
                              this.state.selectedLeadsIds.length !== 0 ? (
                              <AddCandidatesToProjectModal
                                showModal={
                                  this.state.showAddLeadsToProjectModal &&
                                  this.state.projectMoveAction
                                }
                                leadIds={this.state.selectedLeadsIds}
                                leadsType={'leads'}
                                hideModal={this.hideAddLeadsToProjectModal}
                                action={this.state.projectMoveAction}
                              />
                            ) : null}
                            <ExportCSVModal
                              show={this.state.showExportCSVModal}
                              onHide={() => this.setState({ showExportCSVModal: false })}
                              data={this.state.allUsers || []}
                            />
                            <LeadQuickViewDrawer
                              visible={this.state.quickViewDrawerVisible}
                              leadId={this.state.quickViewLeadId}
                              onClose={() => this.setState({ quickViewDrawerVisible: false, quickViewLeadId: null })}
                            />
                            <Row
                              className="mt10 mb5"
                              style={{ marginBottom: '10px' }}
                            >
                              {this.props.type !==
                                'swavalamban-connect-kendra' &&
                                this.props.view !== 'tab' ? (
                                <Col
                                  className="leads-table-search-container"
                                  sm={8}
                                  xs={8}
                                >
                                  {/* {console.log(props.searchProps,'search props')} */}

                                  <div>
                                    <input
                                      style={{
                                        border: '1px solid #CBCBCB',
                                        padding: '7px 15px',
                                        width: '-webkit-fill-available',
                                        color: 'black',
                                        margin: 5,
                                      }}
                                      type="text"
                                      placeholder="Search by Name/Mobile"
                                      onChange={this.handleSearch}
                                      value={this.state.searchText}
                                      className="search-input"
                                    />
                                  </div>
                                </Col>
                              ) : null}
                              {this.props.type !==
                                'swavalamban-connect-kendra' &&
                                this.props.view !== 'tab' ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 5,
                                  }}
                                >
                                  <div
                                    className="filter-class d-flex align-items-center justify-content-center"
                                    onClick={this.showFilter}
                                  >
                                    Filter<i className="fas fa-filter"></i>
                                  </div>
                                  <div
                                    className="filter-class d-flex align-items-center justify-content-center ß"
                                    onClick={this.resetFilter}
                                  >
                                    Reset
                                  </div>
                                  <div
                                    className="filter-class d-flex align-items-center justify-content-center"
                                    onClick={() => this.setState({ showExportCSVModal: true })}
                                    style={{
                                      backgroundColor: '#28a745',
                                      borderColor: '#28a745',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Export CSV<i className="fas fa-file-csv" style={{ marginLeft: 5 }}></i>
                                  </div>
                                </div>
                              ) : null}
                            </Row>

                            {/* old */}

                            {false && (<Row>
                              <div className="total-leads-count-container">
                                {/* <span className="total-leads m0">
                                  {'Total Basic: ' +
                                    (this.state.searchText?.length == 0
                                      ? this.state.allUsers.length
                                      : this.state.filteredUsers?.length)}
                                </span> */}
                                <span className="total-leads m0">
                                  {'Total Baseline: ' +
                                    (this.state.searchText?.length == 0
                                      ? this.state.allUsers.length
                                      : this.state.filteredUsers?.length)}
                                </span>
                                <span className="total-leads m0">
                                  {'Cluster Assigned Baseline: ' +
                                    (this.state.searchText.length == 0
                                      ? this.state.allUsers.filter(
                                        lead => lead.clusterName
                                      ).length
                                      : this.state.filteredUsers.filter(
                                        lead => lead.clusterName
                                      ).length)}
                                </span>
                                <span className="total-leads m0">
                                  {'Cluster Unassigned Baseline: ' +
                                    (this.state.searchText.length == 0
                                      ? this.state.allUsers.filter(
                                        lead => !lead.clusterName
                                      ).length
                                      : this.state.filteredUsers.filter(
                                        lead => !lead.clusterName
                                      ).length)}
                                </span>
                              </div>
                            </Row>)}


                            <Row>
                              <div className="total-leads-count-container">
                                <span className="total-leads m0">
                                  {'Total Profiles: ' + (this.state.searchText?.length == 0
                                    ? this.state.allUsers.length
                                    : this.state.filteredUsers?.length)}
                                </span>
                                <span className="total-leads m0">
                                  {'Basic Profiles: ' + (this.state.searchText?.length == 0
                                    ? this.state.allUsers.filter(lead => lead.stage === 'basic').length
                                    : this.state.filteredUsers.filter(lead => lead.stage === 'basic').length)}
                                </span>
                                <span className="total-leads m0">
                                  {'Advanced Profiles: ' + (this.state.searchText?.length == 0
                                    ? this.state.allUsers.filter(lead => lead.stage === 'advance').length
                                    : this.state.filteredUsers.filter(lead => lead.stage === 'advance').length)}
                                </span>
                                <span className="total-leads m0">
                                  {'Cluster Assigned: ' + (this.state.searchText.length == 0
                                    ? this.state.allUsers.filter(lead => lead.clusterName).length
                                    : this.state.filteredUsers.filter(lead => lead.clusterName).length)}
                                </span>
                              </div>
                            </Row>

                            <br />

                            {/* UI for filter chips */}


                            <Row className="mt5 mb5 show-filters-container">
                              {this.state.filterData.fromDate ? (
                                <span>
                                  From Date:{' '}
                                  <span>
                                    {moment(
                                      this.state.filterData.fromDate
                                    ).format('DD-MM-YYYY')}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'fromDate',
                                      null
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData?.village && this.state.filterData.village?.length > 0 ? (
                                <span>
                                  Villages:{' '}
                                  <span>
                                    {this.state.filterData.village.join(', ')}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={() => {
                                      let filterData = this.state.filterData;
                                      filterData['village'] = [];
                                      this.setState({ filterData }, () => {
                                        this.applyFilters();
                                      });
                                    }}
                                  ></i>
                                </span>
                              ) : null}

                              {this.state.filterData.block && this.state.filterData.block.length > 0 ? (
                                <span>
                                  Blocks:{' '}
                                  <span>{this.state.filterData.block.join(', ')}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={() => {
                                      let filterData = this.state.filterData;
                                      filterData['block'] = [];
                                      this.setState({ filterData }, () => {
                                        this.applyFilters();
                                      });
                                    }}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.srlm_associated !== '' && this.state.filterData.srlm_associated !== undefined ? (
                                <span>
                                  SRLM Associated:{' '}
                                  <span>
                                    {this.state.filterData.srlm_associated === 'true' ? 'Yes' : 'No'}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={() => {
                                      let filterData = this.state.filterData;
                                      filterData['srlm_associated'] = '';
                                      this.setState({ filterData }, () => {
                                        this.applyFilters();
                                      });
                                    }}
                                  ></i>
                                </span>
                              ) : null}

                              {this.state.filterData.apiaryStatus ? (
                                <span>
                                  Apiary Status:{' '}
                                  <span>
                                    {this.state.filterData.apiaryStatus}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={() => {
                                      let filterData = this.state.filterData;
                                      filterData['apiaryStatus'] = '';
                                      this.setState({ filterData }, () => {
                                        this.applyFilters();
                                      });
                                    }}
                                  ></i>
                                </span>
                              ) : null}

                              {this.state.filterData.toDate ? (
                                <span>
                                  To Date:{' '}
                                  <span>
                                    {moment(
                                      this.state.filterData.toDate
                                    ).format('DD-MM-YYYY')}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'toDate',
                                      null
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.state ? (
                                <span>
                                  State:{' '}
                                  <span>{this.state.filterData.state}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={e => {
                                      {
                                        {
                                          let u = this.filterUserByClusterID(
                                            this.state.allData,
                                            this.state.filterData.clusterName,
                                            '',
                                            this.state.filterData.district
                                          )

                                          this.setState(prev => ({
                                            allUsers: u,
                                            filterData: {
                                              ...prev.filterData,
                                              state: '',
                                            },
                                          }))
                                        }
                                      }
                                    }}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.district.length ? (
                                <span>
                                  Districts:{' '}
                                  <span>
                                    {this.state.filterData.district.join(', ')}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={e => {
                                      {
                                        {
                                          let u = this.filterUserByClusterID(
                                            this.state.allData,
                                            this.state.filterData.clusterName,
                                            this.state.filterData.state,
                                            []
                                          )

                                          this.setState(prev => ({
                                            allUsers: u,
                                            filterData: {
                                              ...prev.filterData,
                                              district: '',
                                            },
                                          }))
                                        }
                                      }
                                    }}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.clusterName?.length ? (
                                <span>
                                  cluster Name:{' '}
                                  <span>
                                    {this.state.clusterData.find(
                                      it =>
                                        it._id ==
                                        this.state.filterData.clusterName
                                    )?.clusterName || 'Not found'}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={w => {
                                      {
                                        let u = this.filterUserByClusterID(
                                          this.state.allData,
                                          '',
                                          this.state.filterData.state,
                                          this.state.filterData.district
                                        )

                                        this.setState(prev => ({
                                          allUsers: u,
                                          filterData: {
                                            ...prev.filterData,
                                            clusterName: '',
                                          },
                                        }))
                                      }
                                    }}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.bPlanCompleted === true ? (
                                <span>
                                  Business Plan: <span>Completed</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'bPlanCompleted',
                                      null
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.loanAppApplied === true ? (
                                <span>
                                  Loan Application Status: <span>Applied</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'loanAppApplied',
                                      null
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.eSetupInProgress ===
                                true ? (
                                <span>
                                  Enterprise Status: <span>In Progress</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'eSetupInProgress',
                                      null
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.userType ? (
                                <span>
                                  {'User Type: '}
                                  <span>
                                    {this.state.allUserTypes.map(
                                      (userType, i) => {
                                        if (
                                          userType.customUrl ===
                                          this.state.filterData.userType
                                        ) {
                                          return (
                                            <span index={i}>
                                              {userType.name}
                                            </span>
                                          )
                                        } else return null
                                      }
                                    )}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'userType',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.assignedTo ? (
                                <span>
                                  {'Assigned To: '}
                                  <span>
                                    {this.state.allAssignedTo.map(
                                      (assignedTo, i) => {
                                        if (
                                          assignedTo._id ===
                                          this.state.filterData.assignedTo
                                        ) {
                                          return (
                                            <span index={i}>
                                              {this.state.filterData
                                                .userType ===
                                                'swavalamban-connect-kendra'
                                                ? assignedTo.ngoName
                                                : assignedTo.fullName +
                                                ' (' +
                                                assignedTo.email +
                                                ')'}
                                            </span>
                                          )
                                        } else return null
                                      }
                                    )}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'assignedTo',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.taggedTo ? (
                                <span>
                                  {'Tagged To: '}
                                  <span>
                                    {this.state.filterData.taggedTo === 'None'
                                      ? 'None'
                                      : this.state.allSaarthis.map(
                                        (taggedTo, i) => {
                                          if (
                                            taggedTo._id ===
                                            this.state.filterData.taggedTo
                                          ) {
                                            return (
                                              <span index={i}>
                                                {taggedTo.fullName +
                                                  ' (' +
                                                  taggedTo.email +
                                                  ')'}
                                              </span>
                                            )
                                          } else return null
                                        }
                                      )}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'taggedTo',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.cluster &&
                                this.state.filterData.cluster.length ? (
                                <span>
                                  {'Cluster: '}
                                  {this.state.swavalambanFellows.map(
                                    (fellow, i) => {
                                      if (
                                        fellow._id ===
                                        this.state.filterData.cluster
                                      ) {
                                        return (
                                          <span
                                            index={i}
                                            title={`${fellow.fullName} (${fellow.email})`}
                                          >
                                            {fellow.fullName}
                                          </span>
                                        )
                                      } else return null
                                    }
                                  )}
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'cluster',
                                      []
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.bplanAge ? (
                                <span>
                                  {'B-Plan Age above: '}
                                  <span>
                                    {this.state.filterData.bplanAge} day(s)
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'bplanAge',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}

                              {this.state.filterData.minLoanAmount ? (
                                <span>
                                  {'Min Loan Amount: '}
                                  <span>
                                    {this.state.filterData.minLoanAmount}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'minLoanAmount',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.maxLoanAmount ? (
                                <span>
                                  {'Max Loan Amount: '}
                                  <span>
                                    {this.state.filterData.maxLoanAmount}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'maxLoanAmount',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.source ? (
                                <span>
                                  {'Source (Generated Through): '}
                                  <span>{this.state.filterData.source}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'source',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.idea ? (
                                <span>
                                  Business Idea:{' '}
                                  <span>{this.state.filterData.idea}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'idea',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.phase ? (
                                <span>
                                  Phase:{' '}
                                  <span>{this.state.filterData.phase}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'phase',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}

                              {this.state.filterData.audit ? (
                                <span>
                                  Audit Status:{' '}
                                  <span>{this.state.filterData.audit}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'audit',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.paymentClaim ? (
                                <span>
                                  Payment Claim Status:{' '}
                                  <span>
                                    {this.state.filterData.paymentClaim}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'paymentClaim',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {selectedEssString ? (
                                <span>
                                  ESS opted for:{' '}
                                  <span>{selectedEssString}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'essOptedFor',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.scaleUpQuestionnaire ? (
                                <span>
                                  Scale up questionnaire filled:{' '}
                                  <span>
                                    {this.state.filterData.scaleUpQuestionnaire}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'scaleUpQuestionnaire',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData
                                .entrepreneurStoryVerification ? (
                                <span>
                                  Story Verification Status:{' '}
                                  <span>
                                    {
                                      this.state.filterData
                                        .entrepreneurStoryVerification
                                    }
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'entrepreneurStoryVerification',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.sidbiMilestone ? (
                                <span>
                                  SIDBI Payment Milestone:{' '}
                                  <span>
                                    {this.state.filterData.sidbiMilestone}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'sidbiMilestone',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}

                              {this.state.filterData.loanScheme &&
                                this.state.filterData.loanScheme.length ? (
                                <span>
                                  Loan Scheme:{' '}
                                  {/* <span>{this.state.filterData.loanScheme}</span> */}
                                  <span>
                                    {' '}
                                    {this.state.filterData.loanScheme
                                      .map(x => x.name)
                                      .join(', ')}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'loanSchemes',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.gender ? (
                                <span>
                                  Gender:{' '}
                                  <span>{this.state.filterData.gender}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'gender',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.category ? (
                                <span>
                                  Category:{' '}
                                  <span>{this.state.filterData.category}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'category',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.financeType ? (
                                <span>
                                  Finance Type:{' '}
                                  <span>
                                    {this.state.filterData.financeType}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'financeType',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.pwd ? (
                                <span>
                                  PWD: <span>{this.state.filterData.pwd}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'pwd',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.hasComments ? (
                                <span>
                                  Has Comments:{' '}
                                  <span>
                                    {this.state.filterData.hasComments}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'hasComments',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData
                                .businessPlanVerification ? (
                                <span>
                                  Business Plan Verification:{' '}
                                  <span>
                                    {
                                      this.state.filterData
                                        .businessPlanVerification
                                    }
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'businessPlanVerification',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.collateral ? (
                                <span>
                                  Collateral:{' '}
                                  <span>
                                    {this.state.filterData.collateral}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'collateral',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.bankAccounts &&
                                this.state.filterData.bankAccounts.length ? (
                                <span>
                                  Has Account in Bank:{' '}
                                  <span>
                                    {this.state.filterData.bankAccounts.join(
                                      ', '
                                    )}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'bankAccounts',
                                      []
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.filedIncomeTax ? (
                                <span>
                                  Filed Income Tax:{' '}
                                  <span>
                                    {this.state.filterData.filedIncomeTax}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'filedIncomeTax',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.modeOfApplication ? (
                                <span>
                                  Mode of Loan Application:{' '}
                                  <span>
                                    {this.state.filterData.modeOfApplication}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'modeOfApplication',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.landOwnerShip ? (
                                <span>
                                  Land Ownership:{' '}
                                  <span>{this.state.filterData.landOwnerShip}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'landOwnerShip', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.takenanyloan ? (
                                <span>
                                  Previous Loans:{' '}
                                  <span>{this.state.filterData.takenanyloan}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'takenanyloan', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.practiceBeekeeping ? (
                                <span>
                                  Practice Beekeeping:{' '}
                                  <span>{this.state.filterData.practiceBeekeeping}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'practiceBeekeeping', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.trainedinBeekeepingProgram ? (
                                <span>
                                  Beekeeping Training:{' '}
                                  <span>{this.state.filterData.trainedinBeekeepingProgram}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'trainedinBeekeepingProgram', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.interestedinMoreBeeBoxes ? (
                                <span>
                                  Box Interest:{' '}
                                  <span>{this.state.filterData.interestedinMoreBeeBoxes}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'interestedinMoreBeeBoxes', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.useChemical ? (
                                <span>
                                  Chemical Pesticides:{' '}
                                  <span>{this.state.filterData.useChemical}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'useChemical', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.ownCattle ? (
                                <span>
                                  Livestock Owner:{' '}
                                  <span>{this.state.filterData.ownCattle}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'ownCattle', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.education ? (
                                <span>
                                  Education Level:{' '}
                                  <span>{this.state.filterData.education}</span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(this, 'education', '')}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.overallSentiment ? (
                                <span>
                                  Overall Sentiment:{' '}
                                  <span>
                                    {this.state.filterData.overallSentiment}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'overallSentiment',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData
                                .tentativeHorizonToCloseThis ? (
                                <span>
                                  Eagerness to start the enterprise:{' '}
                                  <span>
                                    {
                                      this.state.filterData
                                        .tentativeHorizonToCloseThis
                                    }
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'tentativeHorizonToCloseThis',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.strengthRating ? (
                                <span>
                                  Strength Rating:{' '}
                                  <span>
                                    {this.state.filterData.strengthRating}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'strengthRating',
                                      ''
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.maturityStatus.length ? (
                                <span>
                                  Maturity Status:{' '}
                                  <span>
                                    {this.state.filterData.maturityStatus.join(
                                      ', '
                                    )}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'maturityStatus',
                                      []
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {this.state.filterData.capitalFulfilledStatus
                                .length ? (
                                <span>
                                  Capital Fulfilled Status:{' '}
                                  <span>
                                    {this.state.filterData.capitalFulfilledStatus.join(
                                      ', '
                                    )}
                                  </span>
                                  <i
                                    className="remove-filter-btn fa fa-times"
                                    onClick={this.removeFilter.bind(
                                      this,
                                      'capitalFulfilledStatus',
                                      []
                                    )}
                                  ></i>
                                </span>
                              ) : null}
                              {!this.props.sidebarMinimized &&
                                this.state.filterData.capitalFulfilledStage ? (
                                <span>
                                  Capital Fulfilled Stages
                                  {this.state.filterData
                                    .capitalFulfilledStages &&
                                    this.state.filterData.capitalFulfilledStages
                                      .length ? (
                                    <span>
                                      <span>
                                        {': '}
                                        {this.state.filterData.capitalFulfilledStages.join(
                                          ', '
                                        )}
                                      </span>
                                      <i
                                        className="remove-filter-btn fa fa-times"
                                        onClick={this.removeFilter.bind(
                                          this,
                                          'capitalFulfilledStages',
                                          []
                                        )}
                                      ></i>
                                    </span>
                                  ) : (
                                    <span>
                                      <i
                                        className="remove-filter-btn fa fa-times"
                                        onClick={this.removeFilter.bind(
                                          this,
                                          'capitalFulfilledStage',
                                          false
                                        )}
                                      ></i>
                                    </span>
                                  )}
                                </span>
                              ) : null}
                            </Row>

                            <BootstrapTable
                              {...props.baseProps}
                              id="leads-page-table"
                              rowStyle={this.rowClassNameFormat}
                              remote={{ pagination: true }}
                              onTableChange={this.onTableChange}
                              {...paginationTableProps}
                              selectRow={selectRow}
                            />
                            <PaginationListStandalone {...paginationProps} />
                            <SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                ) : null}
              </Col>
            </LoadingOverlay>
          </div>
          {this.state.showImportModal ? (
            this.state.importing ? (
              <Modal
                className="upload-candidates-modal"
                show={this.state.showImportModal}
                size="lg"
              >
                <Modal.Body>
                  <i className="fa fa-cog fa-spin fa-3x fa-fw" />
                </Modal.Body>
              </Modal>
            ) : (
              <Modal
                className="upload-candidates-modal"
                show={this.state.showImportModal}
                size="lg"
              >
                <Modal.Header>
                  <Modal.Title className="modal-header-custom">
                    Import Candidate profiles from a CSV
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="mb20">
                  <Row>
                    <Col md={12}>
                      <label className="control-label is-imp">
                        Upload Candidates File (Only csv, xlsx accepted)
                      </label>
                      <input
                        className="form-control upload-file-input"
                        type="file"
                        style={{ width: '100%' }}
                        placeholder="Upload File"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx, .xls"
                        onChange={this.changeUploadHandler.bind(this)}
                      />
                      {/* <note className="note">Note: Kindly upload the csv with the following header rows- Name, Mobile*, Source*, Skills*, Pincode (Mandatory rows are marked with *)</note> */}
                      <span className="note">
                        Note: Kindly upload the csv file with the following
                        header rows- Generated Through, State*, Name*, Address*,
                        Pincode*, Mobile*, Alternative Mobile, Email, Gender*,
                        Category*, Qualification*, Date of Birth*, Block*,
                        District*, Industry Type, Business Idea, Idea Details,
                        Self Investment, Loan Amount, Bank Name, IFSC, Comments,
                        Follow up date (Mandatory rows are marked with *).{' '}
                      </span>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="footer-center">
                  <Button
                    className="btn btn-danger brand-color-background"
                    onClick={this.hideImportCandidatesModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-warning brand-color-background"
                    disabled={!this.state.candidatesImportFile}
                    onClick={this.submitCandidates}
                  >
                    Import
                  </Button>
                </Modal.Footer>
              </Modal>
            )
          ) : null}
        </div>
        {this.props.type !== 'swavalamban-connect-kendra' && this.state.showFilter ? (
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "95%",
                maxWidth: "480px",
                maxHeight: "90vh",
                background: "white",
                borderRadius: "10px",
                padding: "20px",
                overflowY: "auto",
                boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
                position: "relative",
              }}
            >
              <div
                onClick={() => this.showFilter()}
                style={{
                  color: 'white',
                  backgroundColor: '#ef5a20',
                  height: 35,
                  width: 35,
                  marginLeft: '91%',
                  fontWeight: 'bold',
                  fontSize: 16,
                  padding: '5px 10px',
                  borderRadius: 19,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  cursor: 'pointer',
                }}
              >
                X
              </div>

              <Row>
                {/* State Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">State</label>
                    <Searchable
                      placeholder="Select State"
                      value={this.state.filterData.state}
                      notFoundText="No result found"
                      noInput
                      options={this.state.allStates.map((state, index) => ({
                        label: state.name,
                        value: state.name,
                      }))}
                      onSelect={value => {
                        this.changeStateFilter(value)
                        let u = this.filterUserByClusterID(
                          this.state.allData,
                          this.state.filterData.clusterName,
                          value,
                          this.state.filterData.district
                        )
                        this.setState(prev => ({
                          allUsers: u,
                          filterData: {
                            ...prev.filterData,
                            state: value,
                          },
                        }))
                      }}
                      listMaxHeight={200}
                    />
                  </div>
                </Col>

                {/* District Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">District</label>
                    <Searchable
                      placeholder={this.state.filterData.state ? "Select District" : "Select state first"}
                      value={this.state.filterData.district}
                      multiple
                      hideSelected
                      options={this.state.allDistricts.map((district, index) => ({
                        label: district.name,
                        value: district.name,
                      }))}
                      onSelect={value => {
                        this.changeDistrictFilter(value);
                      }}
                      disabled={!this.state.filterData.state}
                    />
                  </div>
                </Col>

                {/* Block Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Block</label>
                    <Searchable
                      placeholder={this.state.filterData.district && this.state.filterData.district.length > 0 ? "Select Block" : "Select district first"}
                      value={this.state.filterData.block}
                      multiple
                      hideSelected
                      options={this.state.allBlocks.map((block, index) => ({
                        label: block,
                        value: block,
                      }))}
                      onSelect={value => {
                        let filterData = this.state.filterData;
                        filterData['block'] = value;
                        this.setState({ filterData }, () => {
                          this.applyFilters();
                        });
                      }}
                      disabled={!this.state.filterData.district || this.state.filterData.district.length === 0}
                    />
                  </div>
                </Col>

                {/* Village Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Village</label>
                    <Searchable
                      placeholder={this.state.filterData.state ? "Select Village" : "Select state first"}
                      value={this.state.filterData.village}
                      multiple
                      hideSelected
                      options={this.state.allVillages.map((village, index) => ({
                        label: village,
                        value: village,
                      }))}
                      onSelect={value => {
                        let filterData = this.state.filterData;
                        filterData['village'] = value;
                        this.setState({ filterData }, () => {
                          this.applyFilters();
                        });
                      }}
                      disabled={!this.state.filterData.state}
                    />
                  </div>
                </Col>

                {/* Project Name Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Project Name</label>
                    <Searchable
                      placeholder="Select Project Name"
                      value={this.state.filterData.projectName}
                      multiple
                      hideSelected
                      options={[...new Set(this.state.allData.map(item => item.projectName).filter(Boolean))].map(projectName => ({
                        label: projectName,
                        value: projectName,
                      }))}
                      onSelect={value => {
                        this.changeFilterHandlerHumblebee("projectName", value)
                      }}
                      disabled={isUserRestricted()}
                    />
                  </div>
                </Col>

                {/* Gender Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Gender</label>
                    <Searchable
                      placeholder="Select Gender"
                      value={this.state.filterData.gender || undefined}
                      options={[
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                        { label: "Other", value: "Other" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("gender", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* SRLM Associated Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">SRLM Associated</label>
                    <Searchable
                      placeholder="Select SRLM Status"
                      value={
                        this.state.filterData.srlm_associated !== "" &&
                          this.state.filterData.srlm_associated !== undefined
                          ? this.state.filterData.srlm_associated
                          : undefined
                      }
                      options={[
                        { label: "All", value: "" },
                        { label: "Yes", value: "true" },
                        { label: "No", value: "false" }
                      ]}
                      onSelect={(value) => {
                        this.setState(
                          prev => ({
                            filterData: {
                              ...prev.filterData,
                              srlm_associated: value !== undefined ? value : ""
                            }
                          }),
                          () => {
                            this.applyFilters();
                          }
                        );
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Apiary Status Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Apiary Status</label>
                    <Searchable
                      placeholder="Select Apiary Status"
                      value={this.state.filterData.apiaryStatus || undefined}
                      options={[
                        { label: "All", value: "" },
                        { label: "Active", value: "Active" },
                        { label: "Inactive", value: "Inactive" },
                        { label: "Absent", value: "Absent" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("apiaryStatus", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Stage Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Stage</label>
                    <Searchable
                      placeholder="Select Stage"
                      value={this.state.filterData.stage || undefined}
                      options={[
                        { label: "Basic", value: "basic" },
                        { label: "Advanced", value: "advance" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("stage", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Reported By / Surveyed By Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Reported By / Surveyed By</label>
                    <Searchable
                      placeholder="Select Surveyor"
                      value={this.state.filterData.reportedBy || []}
                      multiple
                      hideSelected
                      options={[
                        ...new Set(
                          (this.state.allData || [])
                            .map(item => item.surveyorName)
                            .filter(name => name && typeof name === 'string' && name.trim() !== '' && name !== '-')
                        )
                      ]
                        .sort()
                        .map(name => ({
                          label: name,
                          value: name,
                        }))}
                      onSelect={value => {
                        this.changeFilterHandlerHumblebee("reportedBy", value)
                      }}
                      notFoundText="No surveyor found"
                    />
                  </div>
                </Col>

                {/* Cluster Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Filter users by assigned to cluster</label>
                    <Searchable
                      placeholder="Select Cluster"
                      value={this.state.filterData.clusterName || undefined}
                      notFoundText="No result found"
                      noInput
                      options={this.state.clusterData.map((cluster, index) => ({
                        label: cluster.clusterName,
                        value: cluster._id,
                      }))}
                      onSelect={e => {
                        let u = this.filterUserByClusterID(
                          this.state.allData,
                          e,
                          this.state.filterData.state,
                          this.state.filterData.district
                        )
                        this.setState(prev => ({
                          allUsers: u,
                          filterData: {
                            ...prev.filterData,
                            clusterName: e,
                          },
                        }))
                      }}
                      listMaxHeight={105}
                    />
                  </div>
                </Col>

                {/* Land Ownership Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Land Ownership</label>
                    <Searchable
                      placeholder="Select Land Ownership"
                      value={this.state.filterData.landOwnerShip || undefined}
                      options={[
                        { label: "Self Owned", value: "Self Owned" },
                        { label: "Rented", value: "Rented" },
                        { label: "No Land", value: "No Land" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("landOwnerShip", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Previous Loans Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Previous Loans</label>
                    <Searchable
                      placeholder="Select Loan Status"
                      value={this.state.filterData.takenanyloan || undefined}
                      options={[
                        { label: "Yes, took a loan and paid it off", value: "Yes, I took a loan and paid it off" },
                        { label: "Yes, took a loan & it is due", value: "Yes, took a loan & it is due" },
                        { label: "No, have not taken a loan", value: "No, have not taken a loan" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("takenanyloan", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Practice Beekeeping Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Practice Beekeeping</label>
                    <Searchable
                      placeholder="Select Practice Beekeeping"
                      value={this.state.filterData.practiceBeekeeping || undefined}
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("practiceBeekeeping", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Beekeeping Training Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Beekeeping Training</label>
                    <Searchable
                      placeholder="Select Training Status"
                      value={this.state.filterData.trainedinBeekeepingProgram || undefined}
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("trainedinBeekeepingProgram", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Box Interest Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Box Interest</label>
                    <Searchable
                      placeholder="Select Box Interest"
                      value={this.state.filterData.interestedinMoreBeeBoxes || undefined}
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("interestedinMoreBeeBoxes", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Chemical Pesticides Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Chemical Pesticides</label>
                    <Searchable
                      placeholder="Uses Chemical Pesticides"
                      value={this.state.filterData.useChemical || undefined}
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("useChemical", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Livestock Owner Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Livestock Owner</label>
                    <Searchable
                      placeholder="Owns Livestock"
                      value={this.state.filterData.ownCattle || undefined}
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("ownCattle", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Education Level Filter */}
                <Col md={12} className="mb-3">
                  <div className="assigned-to-cluster-filter">
                    <label className="control-label">Education Level</label>
                    <Searchable
                      placeholder="Select Education"
                      value={this.state.filterData.education || undefined}
                      options={[
                        { label: "Uneducated", value: "Uneducated" },
                        { label: "Class 5", value: "Class 5" },
                        { label: "Class 8", value: "Class 8" },
                        { label: "Class 10", value: "Class 10" },
                        { label: "Class 12", value: "Class 12" },
                        { label: "Diploma", value: "Diploma" },
                        { label: "Graduate", value: "Graduate" },
                        { label: "Post Graduate", value: "Post Graduate" }
                      ]}
                      onSelect={(value) => {
                        this.changeFilterHandlerHumblebee("education", value)
                      }}
                      hideSelected
                      multiple={false}
                      notFoundText="No result found"
                      listMaxHeight={140}
                    />
                  </div>
                </Col>

                {/* Reset Button */}
                <Col md={12}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      margin: '20px 0px 10px 0px',
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        padding: '10px 25px',
                        borderRadius: 8,
                        background: 'rgb(239, 90, 32)',
                        color: 'white',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                      }}
                      className="reset-btn"
                      onClick={this.resetFilter}
                    >
                      Reset All Filters
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ) : null}
      </>
    )
  }

  changeUploadHandler = value => {
    let candidatesImportFile = value.target.files[0]
    this.setState({ candidatesImportFile })
  }

  // STEP 5: ADD changeDistrictFilter for cascading
  changeDistrictFilter = (value) => {
    let filterData = this.state.filterData;
    filterData['district'] = value || [];
    filterData['village'] = [];  // Reset village when district changes
    filterData['block'] = [];     // Reset block when district changes

    // Get villages and blocks for selected districts
    const { villages, blocks } = this.getUniqueLocations(
      this.state.allData,
      filterData.state,
      value
    );

    this.setState({
      filterData,
      allVillages: villages,
      allBlocks: blocks
    }, () => {
      this.applyFilters();
    });
  };

  hideImportCandidatesModal = () => {
    this.setState({
      showImportModal: false,
      importStage: '',
      candidatesImportFile: null,
    })
  }

  submitCandidates = () => {
    this.setState({ importing: true })
    let { candidatesImportFile } = this.state
    if (candidatesImportFile) {
      let formData = new FormData()
      formData.append('candidatesFile', candidatesImportFile)
      fetch(process.env.REACT_APP_API_URL + '/api/v1/swati-leads/upload', {
        method: 'POST',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        body: formData,
      })
        .then(data => data.json())
        .then(data => {
          // this.setState({ importing: false });
          if (data.status) {
            let htmlToShow = <></>
            if (data.results.disqualified) {
              htmlToShow = (
                <Accordion>
                  {' '}
                  <Card bg="success">
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="6">
                        Some leads were successfully diqualified - (
                        {data?.results?.disqualified
                          ? data.results.disqualified.length
                          : 0}
                        )
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="6">
                      <Card.Body>
                        {data?.results?.disqualified.length ? (
                          <>
                            {data.results.disqualified.join(', ')}{' '}
                            <CopyToClipboard
                              text={data.results.disqualified.join(', ')}
                              onCopy={() => {
                                this.notifySuccess('Copied')
                              }}
                            >
                              <Button
                              //  onClick={() => {
                              //    incrementRow(row.id, "English");
                              //  }}
                              >
                                Copy to clipboard
                              </Button>
                            </CopyToClipboard>
                          </>
                        ) : (
                          'None of the numbers were disqualified!'
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            } else if (data.results.bplanUpdations) {
              htmlToShow = (
                <Accordion>
                  {' '}
                  <Card bg="success">
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="7">
                        B-Plan links updated for some leads - (
                        {data?.results?.bplanUpdations
                          ? data.results.bplanUpdations.length
                          : 0}
                        )
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="7">
                      <Card.Body>
                        {data?.results?.bplanUpdations.length ? (
                          <>
                            {data.results.bplanUpdations.join(', ')}{' '}
                            <CopyToClipboard
                              text={data.results.bplanUpdations.join(', ')}
                              onCopy={() => {
                                this.notifySuccess('Copied')
                              }}
                            >
                              <Button
                              //  onClick={() => {
                              //    incrementRow(row.id, "English");
                              //  }}
                              >
                                Copy to clipboard
                              </Button>
                            </CopyToClipboard>
                          </>
                        ) : (
                          'No B-plan links to upload!'
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            } else {
              htmlToShow = (
                <Accordion>
                  <Card bg="success">
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="6">
                        Successfully Created Profiles - (
                        {data?.results?.success
                          ? data.results.success.length
                          : 0}
                        )
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        {data?.results?.success.length ? (
                          <>
                            {data.results.success.join(', ')}
                            <CopyToClipboard
                              text={data.results.success.join(', ')}
                              onCopy={() => {
                                this.notifySuccess('Copied')
                              }}
                            >
                              <Button
                              //  onClick={() => {
                              //    incrementRow(row.id, "English");
                              //  }}
                              >
                                Copy to clipboard
                              </Button>
                            </CopyToClipboard>
                          </>
                        ) : (
                          'None of the numbers were uploaded!'
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                  {/* updatedNumbers */}
                  {data?.results?.updatedNumbers.length ? (
                    <Card bg="info">
                      <Card.Header>
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey="4"
                        >
                          Rows with updated numbers - (
                          {data?.results?.updatedNumbers
                            ? data.results.updatedNumbers.length
                            : 0}
                          )
                        </Accordion.Toggle>
                      </Card.Header>

                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          {data?.results?.updatedNumbers ? (
                            <>
                              {data.results.updatedNumbers.join(', ')}
                              <CopyToClipboard
                                text={data.results.updatedNumbers.join(', ')}
                                onCopy={() => {
                                  this.notifySuccess('Copied')
                                }}
                              >
                                <Button
                                //  onClick={() => {
                                //    incrementRow(row.id, "English");
                                //  }}
                                >
                                  Copy to clipboard
                                </Button>
                              </CopyToClipboard>
                            </>
                          ) : (
                            'No numbers updated!'
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ) : null}
                  <hr />
                  {data?.results?.noNumbers.length ? (
                    <Card bg="danger">
                      <Card.Header>
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey="1"
                        >
                          Rows with no/invalid mobile numbers! - (
                          {data?.results?.noNumbers
                            ? data.results.noNumbers.length
                            : 0}
                          )
                        </Accordion.Toggle>
                      </Card.Header>
                    </Card>
                  ) : null}
                  {/* repeatNumbers */}
                  {/* {data?.results?.repeatNumbers.length ? (
                  <Card bg="danger">
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="4">
                        Rows with repeated numbers - (
                        {data?.results?.repeatNumbers
                          ? data.results.repeatNumbers.length
                          : 0}
                        )
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="4">
                      <Card.Body>
                        {data?.results?.repeatNumbers
                          ? data.results.repeatNumbers.join(", ")
                          : "No numbers repeated:)"}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ) : null} */}

                  {data?.results?.invalidMandatoryFields.length ? (
                    <Card bg="danger">
                      <Card.Header>
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey="2"
                        >
                          Invalid Mandatory Fields - (
                          {data?.results?.invalidMandatoryFields
                            ? data.results.invalidMandatoryFields.length
                            : 0}
                          )
                        </Accordion.Toggle>
                      </Card.Header>

                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          {data?.results?.invalidMandatoryFields ? (
                            <>
                              {data.results.invalidMandatoryFields.join(', ')}
                              <CopyToClipboard
                                text={data.results.invalidMandatoryFields.join(
                                  ', '
                                )}
                                onCopy={() => {
                                  this.notifySuccess('Copied')
                                }}
                              >
                                <Button
                                //  onClick={() => {
                                //    incrementRow(row.id, "English");
                                //  }}
                                >
                                  Copy to clipboard
                                </Button>
                              </CopyToClipboard>
                            </>
                          ) : (
                            'No errors:)'
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ) : null}
                  {data?.results?.invalidBankFields.length ? (
                    <Card bg="danger">
                      <Card.Header>
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey="3"
                        >
                          Invalid Bank Details Fields - (
                          {data?.results?.invalidBankFields
                            ? data.results.invalidBankFields.length
                            : 0}
                          )
                        </Accordion.Toggle>
                      </Card.Header>

                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          {data?.results?.invalidBankFields ? (
                            <>
                              {data.results.invalidBankFields.join(', ')}
                              <CopyToClipboard
                                text={data.results.invalidBankFields.join(', ')}
                                onCopy={() => {
                                  this.notifySuccess('Copied')
                                }}
                              >
                                <Button
                                //  onClick={() => {
                                //    incrementRow(row.id, "English");
                                //  }}
                                >
                                  Copy to clipboard
                                </Button>
                              </CopyToClipboard>
                            </>
                          ) : (
                            'No errors:)'
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ) : null}
                </Accordion>
              )
            }
            reactswal({
              content: htmlToShow,
              title: data.title,
              icon: 'success',
            })
              // .then();
              // Swal.fire({
              //   title: data.title,
              //   html: htmlToShow,
              //   type: data.type || 'success'
              // })
              .then(res => {
                if (data.status) {
                  this.getAllLeads()
                  this.hideImportCandidatesModal()
                }
              })
          } else {
            Swal.fire({
              title: 'Error in exporting lead profiles!',
              html: data.errorMessage,
              type: 'error',
            })
          }
        })
      this.setState({ importing: false })
    } else {
      Swal.fire('Oops! Select a file to upload first', 'Import failed', 'error')
    }
  }
  showRedirectModal = id => {
    // Swal.fire({
    //   title: 'Are you interacting with this person?',
    //   html: 'Do you want to add notes of this conversation as comments?',
    //   showCloseButton: true,
    //   showCancelButton: true,
    //   focusConfirm: false,
    //   confirmButtonText: 'Yes, I wish to add notes',
    //   confirmButtonAriaLabel: 'Yes, I wish to add notes',
    //   cancelButtonText: 'No, I do not have anything to add',
    //   cancelButtonAriaLabel: 'No, I do not have anything to add'
    // }).then((result) => {
    //   if (result.value) {
    //     window.location.pathname = '/lead/' + id + '/comments';
    //   } else if(result.dismiss === 'cancel') {
    //   	window.location.pathname = '/lead/' + id;
    //   }
    // });
  }
}
